export const CN = {
  RESTORE: {
    TITLE: '恢复访问',
    IIN_SUBTITLE: '请输入注册网上银行时填写的纳税人识别码',
    PHONE_SUBTITLE: '请输入网上银行注册时登记的手机号码',
  },
  AUTH: {
    LOGIN_TITLE: '登录',
    LOGIN_SUBTITLE: '企业网上银行',
    REGISTER: '进行注册',
    LOGIN: '登录',
    SET_PASSWORD: '设置密码',
    LOGIN_OB_BROWSER: '用于通过浏览器登录 Optima Business',
    UNEXPECTED_ERROR: '系统意外错误。请稍后重试',
    NOT_FOUND_COMPANY: '无公司信息',
    CHECK: {
      CAPSLOCK: '已开启大写锁定 ',
      LANGUAGE: '检查输入语言',
      CAPSLOCK_AND_LANGUAGE: '检查输入语言和锁定键',
    },
    PASSWORD: {
      TITLE: '密码',
    },
    INVALID: '客户ID或密码错误',
    ENTER_ID: '输入客户ID',
    ENTER_PASSWORD: '输入密码',
    CODE: {
      SEND_NEW: '获取新验证码',
    },
    TOTP_CODE: {
      ERROR: 'TOTP验证码错误。请重试。',
    },
    LOCK: {
      DATA_VERIFICATION: '请稍等，系统审核中',
      DATA_VERIFICATION_LABEL: '如果一切正常，该板块将在审核后开放',
    },
  },
  PERSONAL_QR: {
    TITLE: '个人二维码',
    SOON: {
      TITLE: '个人二维码即将推出',
      TEXT: '可为每个客户生成二维码，并注明付款用途——付款事由、收款方、金额',
    },
  },
  RESET_PASSWORD: {
    TITLE: '重置密码',
    SUB_TITLE: '用于登录 Optima Business',
    PHONE: '请输入您的手机号码',
    FINISH: {
      TITLE: '您的密码已重置！',
      SUB_TITLE: '一次性密码已发送至您的手机，用于登录系统并设置新密码',
    },
    SMS_CODE: {
      CONFIRMATION: '短信验证',
      ENTER: '请输入发送至您手机号的短信验证码',
      GET_NEW: '{countdown}秒后可获取新验证码',
      OUTDATED: '短信验证码已过期',
      REQUEST: '请向您的手机号请求新验证码',
    },
  },
  HELP: {
    TITLE: '帮助',
    CONTACTS: '联系方式',
    CALL_CENTRE: '呼叫中心',
    CALL_NUMBER: '拨打电话',
    CHAT_SUPPORT: '聊天支持',
    WRITE_WHATSAPP: '通过 WhatsApp 发送消息',
    USER_MANUAL: '授权指南',
  },
  SESSION: {
    CONTINUE: '是否继续当前会话？',
    EXPIRE: '您的会话将在。。。后关闭',
  },
  DIRECTORY: {
    DICTIONARY: '指南',
  },
  INFORMATION: {
    PHONE: '电话号码',
    PHONES: '电话号码',
    PARTY_ID: '客户ID',
  },
  CITY: '比什凯克',
  DIALOG: {
    TO_MAIN: '返回主页',
    RETURN: '返回',
    TRY_AGAIN: '请再次尝试',
    RETURN_HISTORY: '返回记录',
    TO_PAYMENT_CREATE: '正在创建交易',
    SAVE_TEMPLATES: '保存到模版',
    EXIT: '退出',
    CANCEL: '取消',
  },
  SHARED: {
    SOON: {
      TITLE: '即将推出',
      SUB_TITLE: '请稍候',
    },
    NOT_ENOUGH_CHARACTERS: '字符数量不够',
    COMMISSION: '手续费',
    TOTAL: '总计',
    AMOUNT_FROM: '金额起',
    MOUNT_TO: '金额至',
    DATE_FROM: '日期起',
    DATE_TO: '日期止',
    TIME_FROM: '时间起',
    TIME_TO: '时间止',
    TIME: '时间',
    ALL: '全部',
    COMMISSION_BANK: '银行手续费',
    INTERFACE_LANG: '界面语言',
    DATETIME: '日期和时间',
    OPERATION_HISTORY: '交易历史',
    OPERATIONS: '交易',
    NO_DATA: '没有数据',
    ACTION: {
      CHOOSE: '选择',
      ACCEPT: '接受',
      RETURN: '返回',
      EDIT: '编辑',
      CHANGE: '修改',
      OK: '确定',
      YES: '是',
      NO: '否',
      ICON_PDF: '下载 PDF',
      CONFIRM: '确认',
      CREATE: '创建',
      RECREATE: '重新创建',
      IMPORT: '导入',
      CLOSE: '关闭',
      APPLY: '应用',
      RESET: '重置',
      RETRY: '更新',
      ACCESSIBLY: '明白',
      CONTINUE: '继续',
      CANCEL: '取消',
      EXIT: '退出',
      OPEN: '打开',
      FORGOT_PASSWORD: '忘记密码？',
      CANCELED: '撤销',
      ADD: '添加',
      LOOK: '查看',
      DOWNLOAD: '下载',
      BACK: '返回',
      DELETE: '删除',
      REPEAT: '重试',
      REVOKE: '拒绝',
      SIGN: '签署',
      FOR_SIGN: '待签署',
      SAVED: '保存',
      NEXT: '下一步',
      DONE: '完成',
      SWITCH: {
        ON: '开启',
        OFF: '关闭',
      },
      CHOOSE_TEMPLATE: '从模版中选择',
      WRITE_OFF: '扣款',
      SAVE_TEMPLATE: '保存模版',
      ENROLL: '入账',
      RELOAD: '重新加载',
      GOOD: '好的 ',
      COPY: '数据已复制',
      COPY_ACTION: '复制',
      PAYMENTS: '付款',
    },
    COMMENT: '备注',
    OUTGOING: '发出的',
    INCOMING: '收到的',
    REQUISITE: '详细信息',
    RECEIPT_NUMBER: '发送方回执号码',
    SENDER_ACCOUNT: '发送方账户',
    AMOUNT_AFTER_COMMISSION: '扣除手续费后金额',
    ABOUT_PAYMENT: '付款信息',
    FOUND: '已找到',
    CREATED: '创建时间',
    ENROLLMENT_ACCOUNT: '入账账户',
    CHANGES_SAVED: '更改已保存',
    READY: '完成',
    AGREE_FOR_CONTINUE: '请确认以下信息以继续',
    SORTING: '排序',
    FULL_NAME: '姓名',
    CREATED_DATE: '创建日期',
    ADDRESS: '地址',
    CITY: '城市',
    ACTUAL_ADDRESS: '实际居住地',
    PCS: '件',
    MAIN: '主要',
    PHOTO: '照片',
    BACK: '返回',
    ACCOUNT_NUMBER: '账户号码',
    DOWNLOAD: '下载',
    DEPOSITS: '存款',
    INFORMATION: '信息',
    GENERAL: '通用',
    SECURITY: '安全',
    USER_ACCOUNT: '账户',
    STATUS: '状态',
    NUMBER: '号码',
    NUMBER_SYMBOL: '编号',
    TYPE: '类型',
    EXIT: '退出',
    CREATE: '退出',
    PRODUCTS: '产品',
    LOOK: '查看',
    SEE_ALL: '查看全部',
    IMPORT: '导入',
    RETRY: '更新',
    CONTINUE: '继续',
    CANCEL: '取消',
    CANCELED: '撤销',
    CONFIRM: '确认',
    PHONE: '电话',
    INN: '纳税人识别码',
    REGION: '区',
    AIYL_AREA: '乡级行政区',
    KBK: '预算分类代码',
    PASSWORD: '密码',
    ACCOUNT_PASSWORD: '账户密码',
    DONE: '完成',
    FORGOT_PASSWORD: '忘记密码？',
    CONTRACT: '合同',
    REMAINDER: '余额',
    YES: '是',
    NO: '否',
    OK: '确定',
    CURRENCY: '货币',
    DOCUMENT_NUMBER: '文件号',
    SUM: '金额',
    RATE: '汇率',
    FILTER: {
      TITLE: '过滤器',
      SEARCH: '搜索',
      APPLY: '应用',
      RESET: '重置',
    },
    TOTP: {
      CODE: 'TOTP动态码',
      ENTER_CODE: '请输入生成的 TOTP 验证码',
      INVALID_TOTP: 'TOTP 验证码错误。请重试。',
    },
    SWITCH: {
      ON: '开启',
      OFF: '关闭',
    },
    SAVE: {
      SAVED: '保存',
      SUCCESSFUL: '保存成功',
      CHANGES: '保存更改',
    },
    SMS: {
      TITLE: '短信',
    },
    SIGN_TYPE: {
      ONE_SIGNATORY: '单人签署',
      TWO_SIGNATORY: '双人签署',
    },
    SIGN_RIGHT: {
      AUDITOR: '审计员',
      CREATOR: '执行人',
      FIRST: '第一签署人',
      SECOND: '第二签署人',
      THIRD: '第三签署人',
      NONE: '无权限',
      CASH_MANAGER: '经理',
      CASHIER: '收银员',
    },
    ERROR_PLACEHOLDER: {
      SUBTITLE: '请刷新页面',
      TITLE: '服务器错误',
    },
    SYSTEM_ERROR: '系统意外错误。请稍后重试',
    ACCOUNT: {
      TITLE: '我的产品',
      RKO: '账户',
      CARD: '银行卡',
      DEPOSIT: '存款',
      SETTLEMENT_ACCOUNTS: '结算账户',
      CARDS: '银行卡',
    },
    RULE: {
      FILL_FIELD: '请填写此栏！',
      FILL_LATIN: '请用拉丁字母填写此栏!',
      NEW_OLD_PASSWORD_REPEATED: '新密码必须与当前密码不同',
      CONVERSION_AMOUNT_EXCEEDS_BALANCE: '兑换金额超过账户可用余额',
      PAYMENT_AMOUNT_EXCEEDS_BALANCE: '付款金额超过账户可用余额',
      ACCOUNT_INSUFFICIENT_FUNDS: '账户余额不足',
      INCORRECT_DATE: '日期不正确',
      INCORRECT_TIME: '时间不正确',
      INCORRECT_SYMBOLS: '不允许使用的字符 {value}',
      INCORRECT_MANUAL_RATE: '约定汇率无效',
      INCORRECT_PERCENTAGE_DIFFERENCE: '无效数值！',
      NO_ACCESS_OPERATION: '无权进行此操作！',
      FORBIDDEN_SEND_EXTERNAL_ACCOUNT: '禁止向外部账户转账',
      SAME_DEBIT_ACCOUNT: '与扣款账户相同',
      TIME_EXPIRED: '因时间限制。该操作暂不可用',
      PAY_CONTROL_NOT_EXIST: '移动应用不支持 优盾或 TOTP 签名。请在网站上对交易进行签名。',
      PAY_CONTROL_NOT_AVAILABLE: '无法提交付款签署。其中一位签署人未开通PayControl',
      INCORRECT_INN: '纳税人识别码无效',
      INCORRECT_DATA: '数据无效',
      INCORRECT_PASSWORD: '密码错误',
      ONE_YEAR_PERIOD: '您只能选择一年内的查询周期',
      MONTH_PERIOD: '您只能选择31天内的查询周期',
      MAX_LENGTH: '最大输入长度 {length} 个字符',
      MIN_LENGTH: '最小输入长度 {length} 个字符',
      CLIENT_NOT_FOUND: '未找到客户。请检查输入的数据是否正确',
      IBAN: '账户结构不符合IBAN标准',
      OUTLET_CHECK: '仅支持字母、数字、空格和连字符',
      NOT_EMOJI: '不支持表情符号',
    },
    SEARCH: '搜索',
    TIME_LIMIT: '可在 {timeFrom} 至 {timeTo} 期间创建付款',
    VALUE_DATE: '起息日期',
    AMOUNT_PAYMENT: '付款金额',
    ACCOUNT_NOT_FOUND: '账户未找到!',
    CHOOSE_TEMPLATE: '从模版中选择',
    NAME_LEGAL_ENTITY: '付款人名称',
    WITHDRAWAL_ACCOUNT: '扣款账户',
    RECIPIENT: '收款人',
    RECIPIENT_NAME: '收款人姓名',
    APPOINTMENT: '用途',
    TYPE_TRANSACTION: '交易类型',
    ENROLL: '入账',
    WRITE_OFF: '扣款',
    PAYMENT_CODE: '付款代码',
    SAVE_TEMPLATE: '保存模版',
    NAME: '名称',
    PAYMENT_DETAILS: '付款详情',
    OPERATION_DETAILS: '交易详情',
    INVOICE_COMMISSION_PAYMENT: '手续费支付账户',
    PAYER: '付款人',
    CLOSE: '关闭',
    BIN: 'BIN（银行识别码）',
    KPP: 'KPP（纳税人登记原因代码）',
    BIC_SWIFT: '银行识别码/SWIFT代码',
    BIC_SWIFT_INTERMEDIARY: '中间行 BIC/SWIFT 代码',
    NOT_FOUND: '未找到数据',
    MORE: '多于',
    LESS: '少于',
    DETAILED_INFO_BY_CALL_CENTER: '您可拨打银行客服热线 9500 获取更详细信息',
    WEEK: {
      MON: '星期一',
      TUE: '星期二',
      WED: '星期三',
      THU: '星期四',
      FRI: '星期五',
      SAT: '星期六',
      SUN: '星期日',
    },
    CONFIRM_CLOSE_TITLE: '确认退出吗？',
    CONFIRM_EXIT_TITLE: '您确定要退出吗？',
    NOT_HAVE_PRODUCTS: '您尚未在 Optima Business 开通任何产品',
  },
  CALCULATOR: {
    CURRENCY_CONVERTOR: '货币计算器',
    TYPE_RATE: '汇率视图',
  },
  FORM_PAYMENT: {
    NOT_ENOUGH_MONEY: '账户余额不足',
    NOT_ENOUGH_MONEY_DESCRIPTION: '预计余额: {plannedBalance} {currency}.\n请输入其他金额或充值',
    NOT_ENOUGH_MONEY_BUTTON: '我将输入另一笔金额',
    INSUFFICIENT_FUNDS_DIALOG: {
      SINGLE_PAYMENT_TITLE: '资金不足，无法将付款发送签署',
      PAYMENT_AMOUNT: '付款金额：',
      AVAILABLE_BALANCE: '可用余额：',
      DESCRIPTION: '您可以修改付款或继续发送签署。',
      EDIT: '修改',
      CONTINUE: '继续',
    },
    CONVERSION: {
      PURCHASE: '设定买入汇率',
      CONTRACTUAL_PURCHASE: '协议买入汇率',
      SALES: '设定卖出汇率',
      CONTRACTUAL_SALES: '协议卖出汇率',
      CONVERSION: '设定兑换汇率',
      CONTRACTUAL_CONVERSION: '协议兑换汇率',
      ENROLLMENT_ACCOUNT: '收款账户',
      DIDNT_LOAD: '汇率未加载，请刷新',
      RESET_VALUE_RATE: '返回至已设定状态',
      TEXT_INFO_CONVERSION: '当金额高于 1 万美元时，可协商约定汇率',
    },
    TRANSFER: {
      PAYMENT_CODE: {
        LABEL: '付款代码',
        HINT: '请选择对应用途的代码。支持按代码或名称搜索',
      },
      PAYING_GOODS_SERVICES: '支付商品/服务款项时，请注明商品、服务的名称，以及合同/发票的编号和日期',
      BIC_BANK_NAME: '银行识别码/银行名称',
      NAME_RECIPIENT: '收款人名称',
      NOT_OPERATION_TYPE: '请选择操作类型',
      AVAILABLE_UNTIL: '可用时间自 {timeFrom} 至 {timeTo}',
      MAX_AMOUNT_ONE_MILLION: ' 最高金额不超过 100 万索姆',
      FORBIDDEN_SYMBOL: '& 为禁用字符',
      INTRABANK_RKO_TO_CARD_NOT_ALLOWED: '当前账户为银行卡号账户，请填写对公结算账户',
      ACCOUNT_NOT_EXIST_FOR_OPERATION:
        '对于所选择的扣款账户，当前不提供此""{operation}""操作类型。如需开通权限，请联系第一位签署人',
    },
    SWIFT: {
      COUNTRY: '国家',
      CORRESPONDENT_ACCOUNT: '代理行账户',
      NAME: '名称',
      ACCOUNT_IBAN: '账户/国际银行账号',
      CURRENCY_TRANSACTION_CODE: '名称',
      INTERMEDIARY_BANK: '中间行',
      EXOTIC_CURRENCY: '中间行',
      AVAILABLE_DEBIT_ACCOUNT_IS_EURO: '仅当付款账户币种为欧元时可用',
      CROSS_RATE: '交叉汇率',
      PAYMENT_CODE: {
        LABEL: '付款代码',
        HINT: '请选择与用途相符的代码。支持按代码或名称搜索',
      },
      CARGO:
        '本人承诺，将自货物送达吉尔吉斯斯坦境内之日起3（叁）个工作日内，向‘Optima银行’股份有限公司提供正式文件（海关报关单），证明本次转账所涉商品已实际交付（适用于商品付款转账）',
      TRANSFER_BETWEEN_BANKS: '吉尔吉斯斯坦跨行转账须填写中间行信息',
      RUS_USD_EUR_NOT_ALLOWED: '以美元（USD）和欧元（EUR）向俄罗斯联邦进行的转账暂时不可用',
      RUS_USD_EUR_WARNING:
        '尊敬的客户：通过 SWIFT 以 USD 和 EUR 向俄罗斯联邦进行的转账暂时不可用。如需其他结算方式，请联系银行分行',
      HINT_NAME: '请将“地址”和“城市”填写在上方对应字段中！',
    },
    O24_TRANSFER: {
      BY_PHONE_NUMBER: '通过手机号',
      BY_CARD_NUMBER: '通过手机号',
    },
    LOADING: {
      DRAFT: '付款已保存至草稿',
      SIGNED: '付款已提交等待签字（授权）',
    },
    LIMITS: {
      ONE_TIME: '您已超单次交易限额',
      DAILY: '您已超单日限额！',
      MONTHLY: '您已超单月限额！',
      FOR_DAY: '您已超单日限额！',
      FOR_MONTH: '您已超单月限额！',
    },
    REMOTELY_IDENTIFIED_EXCEPTION: {
      MONTHLY: {
        TITLE: '本月转账额度已用尽',
        SUBTITLE: '请前往银行网点验证账户以解除限制',
      },
      FOR_MONTH: {
        TITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.MONTHLY.TITLE',
        SUBTITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.MONTHLY.SUBTITLE',
      },
      ONE_TIME: {
        TITLE: '转账金额过大',
        SUBTITLE: '请尝试输入前往银行网点验证账户以解除限制',
      },
      OPERATION_NOT_AVAILABLE: {
        TITLE: '仅可向本人名下的卡片转账',
        SUBTITLE: ' 请前往银行网点验证账户以解除限制',
      },
      DAILY: {
        TITLE: '额度已用尽',
        SUBTITLE: '您已超单日限额！',
      },
      FOR_DAY: {
        TITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.DAILY.TITLE',
        SUBTITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.DAILY.SUBTITLE',
      },
    },
    CONFIRM_TRANSFER: {
      TITLE: '确认转账',
      DESCRIPTION: '汇率为预估值，实际结算时可能变动',
      TRANSFER_AMOUNT: '转账金额',
      CREDITED_AMOUNT: '到账金额',
      CONVERSION_RATE: '兑换汇率 ',
    },
    EDITING: '编辑付款信息',
  },
  PAYMENT_DETAILS: {
    VALUE_DATE: '起息日',
    DOCUMENT: '交易流水号',
    WRITE_OFF_AMOUNT: '扣款金额',
    RATE_OPERATION: '交易汇率',
    CREATED: '创建时间',
    ENROLLMENT_AMOUNT: '入账金额',
    BANK: '银行',
    BIC: '银行识别码',
    ACCOUNT: '账户',
    CARD_ACCOUNT: '卡号账户',
    CARD_NUM: '卡号',
    KBK: '预算分类代码',
    PURPOSE: '付款用途',
    CORPORATE_ACCOUNT: '代理行账户',
    RECIPIENT_COUNTRY: '收款人所在国',
    COMMISSION: '手续费',
    COMMISSION_CURRENCY: '手续费币种',
    COMMISSION_ACCOUNT: '手续费扣款账户',
    PAYMENT_CODE: '付款代码',
    OPERATION_ID: '交易流水号',
    EXOTIC_RATE: '稀有货币汇率（美元、欧元、卢布、人民币、坚戈、英镑、人民币、日元除外）',
    OPTION: '选项',
  },
  PASSWORD_WITH_REPEAT: {
    THINK_UP_PASSWORD: '新密码',
    REPEAT_PASSWORD: '再次输入密码',
    PASSWORD_MISMATCH: '密码不一致',
  },
  REVOCATION_REASON_PAYMENT: {
    REASON_FOR_RECALL: '撤销原因',
    ENTER_REASON: '请输入原因',
  },
  SELECTION_PAYMENT_HEADER: {
    SELECT_ALL: '全选',
    OPERATIONS: '交易',
    FOR_AMOUNT: '总额为',
    OPERATION: '交易',
  },
  VISIBLE_ACCOUNT_LIST: {
    MISSING_ACCOUNT: '账户不存在',
    ACCOUNT_VISIBILITY: '账户可见性设置',
  },
  PAYMENT_ACTION: {
    MB_TRANSFER_SOM: '跨行索姆转账',
    MB_TRANSFER: '跨行外币转账',
    CONVERSION: '货币兑换 ',
    INTRABANK_TRANSFER: '行内转账',
    OWN_CARD_TRANSFER: '转账至商务卡',
    O24_TRANSFER: '转账至Optima24',
    CARD_RKO_TRANSFER: '从商务卡转账至结算账户',
    TRANSFER_BY_INVOICE: '支付发票',
    NOT_ALLOWED_BY_SIGN_RIGHT: '您的角色无权创建付款',
  },
  BUDGET: {
    TITLE: '预算支付',
    DATE_EXPIRED: '当前起息日不可创建交易。您是否希望创建下一工作日的交易？- {date}?',
    GNS: {
      TITLE: '国家税务局税款支付',
      OTHER_TAX: '其他税款支付',
      CHATTEL_TAX: '动产税支付',
      REALTY_TAX: '不动产税支付',
      PAYMENT: '按付款代码支付',
    },
    TUNDUK: {
      TITLE: '“Тундук”国家统一服务平台服务费支付',
    },
    AIS_FOREST_USE: '林业管理信息系统',
    GUARANTEE_FEE_ETP_FUGI: '保证金（国有资产管理基金电子交易平台）',
    E_PATENT: '电子专利',
    GUARANTEE_FEE_ETP_MSU: '保证金支付（地方政府电子交易平台）',
    SOCIAL_INSURANCE_PAYMENT: '社会保险缴费',
    INSURANCE_CONTRIBUTION_PAYMENT_BY_CODE: '按支付代码缴纳保险费',
    ELECTRONIC_NOTARY: '电子公证',
    BUDGET_CREDIT_REPAYMENT: '预算贷款偿还',
    JUDICIAL_DEPARTMENT_GUARANTEE_FEE: '最高法院司法部—参与拍卖的保证金',
    JUDICIAL_DEPARTMENT_PROPERTY_PAYMENT: '最高法院司法部—财产价值支付',
    JUDICIAL_DEPARTMENT_ENFORCEMENT_FEE_10_PERCENT: '司法部—支付10%执行费',
    DEADLINE_HINT: '自开始填写起，请在15分钟内完成付款的填写与签署。若未及时签署，付款将不予处理。',
    SOON: '即将推出！',
    PLEASE_WAIT: '请稍候',
    FORM: {
      INPUT_REGION: '选择地区',
      INPUT_TAX_TYPE: '选择税种',
      INPUT_AMOUNT_PAYMENT: '输入金额',
      INPUT_AIYL_AREA: '选择乡级行政区',
      INPUT_WRITE_OFF: '扣款账户',
      AMOUNT_PAYMENT: '支付金额',
      TAX_TYPE: '税种',
      TAX_SUM: '税款金额',
      ENICODE: '统一编码',
      COEFFICIENT_FUNC_PURPOSE: '功能用途系数',
      BOOK_VALUE: '账面价值',
      PERSONAL_ACCOUNT: '个人账户',
      CODE_PAYMENT: '付款代码',
    },
    MAX_AMOUNT: '最高金额 {value}',
    MIN_AMOUNT: '最低金额 {value}',
    PAYMENT_DEADLINE: '付款代码仅在创建当天有效——截至23:59:59',
    PAYMENT_DEADLINE_ERROR: '请输入有效的付款代码。请注意，该代码仅在创建当天——截至23:59有效。',
  },
  FOOTER: {
    COPYRIGHT: '银行股份有限公司',
    YEARS: '© 1992-{year} 年',
  },
  LANGUAGE: {
    RU: '俄语',
    KG: '吉尔吉斯语',
    ENG: '英语',
  },
  HOME: {
    TITLE: '主页',
  },
  HISTORY: {
    TITLE: '交易历史',
    STATUS: {
      CREATION: '创建',
      DRAFT: '草稿',
      TO_DRAFT: '存入草稿',
      PARTIALLY_CONFIRMED: '待签署',
      PARTIALLY_CONFIRMED_SUFFIX: '待您签署',
      ON_VERIFICATION: '待签署',
      ON_VERIFICATION_SUFFIX: '带您签署',
      PARTIAL_CONFIRMATION_COMPLETED: '已由第2签字人签署',
      PARTIAL_CONFIRMATION_COMPLETED_SUFFIX: '已由第2签字人签署',
      ON_VERIFICATION_COMPLETED: '已由第1签字人签署',
      ON_VERIFICATION_COMPLETED_SUFFIX: '已由第1签字人签署',
      CANCELED_SIGN_TWO: '已被第2签字人取消',
      CANCELED_SIGN_ONE: '已被第1签字人取消',
      FOR_EDITING: '已发送编辑',
      REJECTED_SUFFIX: '待您编辑',
      CONFIRMED: '已签署',
      REVOKE: '已撤销',
      WAIT_RESPONSE_FROM_BANK: '处理中',
      CHECK_STATUS_BANK: '检查银行回复',
      PAYMENT_REQUEST_TO_BANK: '正在发送至银行',
      KVIT: '银行已执行',
      SUCCESS: '已完成',
      ERROR: '银行已拒绝',
      UNKNOWN: '错误状态',
      FIRST_SIGN_IN_PAY_CONTROL: '正在发送签署',
      FIRST_SIGN_IN_PAY_CONTROL_COMPLETE: '待签署',
      FIRST_SIGN_IN_PAY_CONTROL_COMPLETE_SUFFIX: '待您签署',
      SECOND_SIGN_IN_PAY_CONTROL: '正在发送签署',
      SECOND_SIGN_IN_PAY_CONTROL_COMPLETE: '待签署',
      SECOND_SIGN_IN_PAY_CONTROL_COMPLETE_SUFFIX: '待您签署',
      TIMEOUT_CANCELED_SIGN_TWO: '超时拒绝',
      TIMEOUT_CANCELED_SIGN_ONE: '超时拒绝',
      PARTIALLY_EXECUTED: '部分完成',
      TIME_IS_OUT: {
        TITLE: '因超时拒绝',
        ERROR: '付款因时间校验未通过，请重试',
      },
    },
    STATUS_HISTORY: {
      DRAFT: '已创建',
      PARTIAL_CONFIRMATION_COMPLETED: '已由第2人签署',
      ON_VERIFICATION_COMPLETED: '已签署',
      ON_VERIFICATION_COMPLETED_SUFFIX: '已由第1人签署',
      CANCELED_SIGN_TWO: '已被第2人取消',
      CANCELED_SIGN_ONE: '已被第1人取消',
      WAIT_RESPONSE_FROM_BANK: '处理中',
      PAYMENT_REQUEST_TO_BANK: '执行请求',
      TIMEOUT_CANCELED_SIGN_TWO: '超时拒绝',
      TIMEOUT_CANCELED_SIGN_ONE: '超时拒绝',
      REVOKE: '已撤回',
      KVIT: '银行已执行',
      SUCCESS: '已完成',
      ERROR: '已拒绝',
    },
    LISTS: {
      ALL: '全部',
      DRAFT: '我的草稿',
      DRAFT_SALARY: '待签署',
      FAILED: '已拒绝的',
      ERROR: '银行已拒绝',
      FOR_SIGN: '待签署',
      FOR_EDITING: '待编辑',
      SUCCESS: '已完成的',
    },
    NOTIFICATIONS: {
      SIGNED: {
        SUCCESS: '付款 {number} 已签署',
        SUCCESS_MULTIPLE: '付款已签署',
        SUCCESS_PARTIAL: '付款部分签署',
        ERROR: '签署付款失败',
        ERROR_MULTIPLE: '付款签署失败',
      },
      SEND_TO_SIGNED: {
        SUCCESS: '签署 {number} 号付款失败',
        SUCCESS_MULTIPLE: '付款已发送签署',
        ERROR: '发送付款签署失败',
        ERROR_AFTER_DRAFT: '此交易已创建为草稿保存，需从交易历史中打开签署',
        ERROR_MULTIPLE: '发送付款签署失败 ',
      },
      SAVED_TO_DRAFT: {
        SUCCESS: '{number} 号付款  已保存至草稿',
        ERROR: '保存付款至草稿失败',
      },
      DELETE_DRAFT: {
        SUCCESS: '草稿 {number} 已删除  ',
        ERROR: '删除草稿失败',
      },
      FOR_EDITING: {
        SUCCESS: ' {number} 号付款被拒',
        ERROR: '拒绝付款失败',
      },
      SEND_TO_EDITING: {
        SUCCESS: ' {number} 号付款 已发送编辑',
        ERROR: '发送付款编辑失败',
      },
      SUCCESS_EDITING: {
        SUCCESS: '付款已成功编辑',
        ERROR: '编辑付款失败',
      },
    },
    TRANSACTION: {
      PAYMENTS_SIGNED: '付款正在签署中…',
      PAYMENT_SIGNED: '№ {number} 付款正在签署中...',
      PAYMENT_CANCELLED: '№ {number} 付款 正在取消中...',
      PAYMENT_SENT_EDITING: '№ {number} 付款正在发送编辑中...',
      PAYMENT_SENT_SIGNING: '№ {number} 付款 正在发送签署中…',
      FILE_DOWNLOADING: '文件下载中...',
      FILE_OPENING: '文件打开中…',
      PAYMENT_REMOVING: '{number} 付款删除中...',
      PAYMENT_SENT_SIGN: '付款正在发送签署中…',
      PAYMENTS_SENT_SIGN: '付款正在发送签署中...',
      PAYMENTS_RESPOND: '付款正在撤回中…',
      PAYMENT_RESPOND: '付款正在撤回中…',
      PAYMENT_UPDATING: '№ {number} 付款更新中...',
      PAYMENT_RECALL: '付款已撤回再编辑',
      PAYMENT_RECALLING: '付款撤回中...',
      ERROR: {
        FOR_SIGN: '发送签署失败',
        PAYMENT_RECALL: '付款撤回失败',
      },
    },
  },
  FILE_UPLOAD: {
    LOADING: '文件加载中',
    FILE_SIZE_EXCEPTION: '文件大小超过允许限制',
    FILE_EXTENSION_EXCEPTION: '文件格式不正确',
    FAILED_SAVE_FILE: '文件保存失败',
    IN_IMPORTED: '已导入',
    FILE_SAVED_SUCCESSFULLY: '文件保存成功',
  },
  HISTORY_PAYMENT_QR: {
    EXTRACT_FORMAT: '请选择格式',
    DOWNLOAD_STATEMENT: '下载对账单',
    TITLE: '二维码支付',
    EXTRACT_EXCEL: '导出至 Excel',
    VALIDATION_ERROR_DATE: '请指定两个日期或时间段以导出至Excel',
    ENROLLED: '已到账',
    TYPE_TRANSACTION: '交易类型',
    TYPE_QR_POS: '二维码类型与POS机号',
    POS_NUMBER: 'POS机编号',
    QR_SERVICE_TYPE: {
      STATIC: '静态的',
      DYNAMIC: '动态的',
      OVERHEAD: '凭发票支付',
      WEB: '在线支付',
      MONITOR: '线下柜台付款',
      INVOICE: '支付凭证',
      PERSONAL_QR_WEB: '个人二维码',
      DEEPLINK_QR: 'Deeplink QR',
    },
    STATUS_SUCCESS: '已完成',
    PAYMENT_FOR_OPTIMA_QR: '通过OptimaQR支付 {senderName}',
    PAYMENT_FOR_QR: '二维码支付',
    EMPTY_HISTORY: '交易列表为空',
    SORTED: {
      TITLE: '按金额排序',
      NONE: '无排序',
      ASC: '按升序排列',
      DESC: '按降序排列',
    },
    DATE_PERIOD: {
      RECENT: '最近的',
      WEEK: '七天内',
      MONTH: '30天内',
    },
    INCOME_TODAY: '今日收入',
    INCOME_YESTERDAY: '昨日收入',
    SALES_SHORT_LABEL: '交易数量',
  },
  QR_REFUND: {
    ABOUT: '关于退款',
    OUTLET_NAME_OR_ACCOUNT: '商户名称',
    OUTLET_ADDRESS: '商户地址',
    RETURNED: '已退款',
    TO_RETURN: '待退款',
    TO_CLIENT: '退款给客户',
    TO_CARD: '原路退回至银行卡',
    TO_REFUND_CHECK: '查看退款凭证',
    CHECK_NUMBER: '单据号',
    RETURN_CHECK_NUMBER: '退款单号',
    SUM: '退款金额 ',
    PURPOSE: '退款原因',
    HINT: '您最多只能执行一次全额或部分退款',
    ONLY_O24: 'OptimaQR 支付的款项',
    ALREADY_RETURNED: '该付款已发起过退款',
    IN_PROCESS: '退款已提交待审批',
    RULES: {
      AMOUNT: '退款金额不得超过原始支付金额',
      PURPOSE: '可输入4到140个字符，除以下字符外，所有特殊字符均允许使用: \\ «» & <>',
    },
    ERRORS: {
      PAYER_ACCOUNT_NOT_ENOUGH_MONEY: '扣款账户余额不足',
      PAYER_ACCOUNT_NOT_ENOUGH_MONEY_HINT: '请充值账户后，再尝试重新发起退款',
      PAYER_ACCOUNT_BLOCKED: '扣款账户已关闭或被冻结',
      PAYER_ACCOUNT_BLOCKED_HINT: '如您是账户持有人，请联系 {department}, 以解冻账户',
      RECIPIENT_ACCOUNT_BLOCKED: '入账账户已被冻结',
      RECIPIENT_ACCOUNT_BLOCKED_HINT: '请客户联系客服以解冻账户',
      RECIPIENT_ACCOUNT_INACTIVE: '扣款账户处于未激活状态',
    },
  },
  QR_PAYMENT: {
    TITLE: '二维码支付',
    SUBTITLE: '二维码支付',
    B2C_O24: 'B2C OptimaQR 支付',
    B2B_O24: '企业通过 OptimaQR 系统向个人发起的收款交易',
    B2B_ELQR: '企业间通过 ELQR 系统进行支付',
    B2G: '企业对政府支付',
  },
  SETTINGS: {
    TITLE: '设置',
    MAIN: {
      PAY_CONTROL: 'Pay Control',
      VISIBILITY_ACCOUNT: '账户可见性',
      CHANGE_PHONE: '修改手机号码',
      CODE_WORD: '预留验证词',
      COMPANY: {
        TITLE: '关于公司',
        NAME: '公司名称',
        SIGN_TYPE: '签字类型',
        SIGN_SCHEME: '付款途径',
        ID_COMPANY: '公司ID',
        DEPARTMENT_NAME: '合同分支机构',
        REGISTER_DATE: '合同注册时间',
      },
      PRIVATE: {
        TITLE: '个人信息',
        NAME: '姓名',
        RIGHTS: '职务身份',
        EMAIL: '邮箱',
        PHONE: '电话号码',
      },
      CONTACTS: {
        TITLE: '银行联系方式',
        WHATS_APP: 'WhatsApp',
        PHONE: '电话',
        EMAIL: '邮箱',
      },
      PAYMENT: {
        TITLE: '关于时间的规定',
        SUBTITLE: 'Optima Business 业务操作时间限制:',
        DESCRIPTION:
          ' 在 Optima Business 中进行业务操作时，注意时间范围的限制。遵守这些规定有助于避免可能出现的处理延迟',
        TYPE: {
          CLEARING: '清算',
          GROSS: '总额',
          SWIFT: 'SWIFT账号',
          INTRABANK_TRANSFER_OWN: '行内转账至本人账户',
          INTRABANK_TRANSFER_FOREIGN: '行内转账至本行其他客户账户',
          RKO_2_BUSINESS_CARD_OWN: '转账至商务卡',
          INTRABANK_TRANSFER_RKO_2_CARD_OWN: '转账至商务卡',
          RKO_2_BUSINESS_CARD_FOREIGN: '转账至Optima24',
          RKO_2_INDIVIDUAL_CARD_FOREIGN: '转账至Optima24',
          RKO_2_INDIVIDUAL_CARD_OWN: '转账至Optima24',
          BUSINESS_CARD_2_RKO_OWN: '从商务卡转账至结算账户',
          BUSINESS_CARD_2_RKO_FOREIGN: '从商务卡转账至结算账户',
          CONVERSION: '货币兑换',
          BUDGET_PAYMENT: '预算支付',
          SALARY: '工资项目',
          TRANSFER_BY_INVOICE: '支付账单',
          REFUND: '二维码支付退款',
          QR: '二维码支付/转账',
        },
        DEFAULT: '其他货币',
        CREATE_OPERATION: '创建交易',
        SIGN_OPERATION: '签署交易',
        TIME: '至 {value}',
      },
    },
    CHANGE_PASSWORD: {
      TITLE: '变更密码',
      SUCCESSFULLY: '修改密码成功',
      FAILED: '密码修改失败',
      CURRENT_OPT_INCORRECT: '当前密码或动态口令错误！',
      LOGIN_OB: '该密码将用于登录Optima Business',
      CURRENT: '当前密码',
    },
    CHANGE_PHONE: {
      NUMBER_OB: '在Optima Business中更换手机号码',
      SUCCESSFULLY: '手机号码已成功更改',
      TRY_ENTER_NEW: '请重新尝试输入',
      ENTER_CODE_SENT: '请输入发送至新手机号码的验证码',
      NEW_OLD_SAME: '新手机号码与已注册号码重复',
      REGISTERED: '手机号码已注册',
      NEW: '新手机号码',
      SMS_CODE: '短信验证码',
    },
    VISIBILITY_ACCOUNT: {
      FAILED_CHANGE_ACCOUNT_VISIBILITY: '账户可见性设置更改失败',
      FAILED_GET_INVOICES: '未能获取账户信息',
    },
    PAY_CONTROL: {
      INFO: 'PayControl 相关信息',
      REGISTRATION: 'PayControl注册',
      SUCCESS_GENERATED: 'PayControl已成功生成',
      ERROR: '生成 Pay Control 时出错',
      IDENTIFIER: '标识代码',
      VALIDITY: '有效期',
      REISSUE_KEY: '重新签发密钥',
      RELEASE_KEY: '签发密钥',
    },
    API_KEY: {
      TITLE: 'API 密钥',
      HELP: {
        LABEL: '什么是 API 密钥',
        DESCRIPTION: '这是一个由字母和数字组成的代码，允许以加密形式进行数据交换',
      },
      DIALOG: {
        SAVE: {
          TITLE: '请确认您已保存 API 密钥',
          MESSAGE: '请点击‘密钥已复制并保存’，然后点击‘完成',
        },
        WARNING: {
          TITLE: '是否要重新生成密钥？',
          MESSAGE: '重新生成将删除当前密钥',
        },
      },
      HINT: '您已有访问权限。密钥有效期为90天。',
      KEY: '密匙',
      KEY_TYPE: '密匙类型',
      KEY_STATE: {
        ACTIVE: '已激活',
        INACTIVE: '您的密钥已停用',
        NEW: '新密匙 ',
      },
      CATEGORIES: {
        QR: '生成二维码',
        QR_DATA_REQUEST: '查询二维码支付数据',
        OUTLET: '销售点和收银机列表',
        POS_OPERATION_STATEMENT: 'POS和二维码支付对账单',
        QR_OPERATION_STATEMENT: '二维码支付对账单',
      },
      KEY_COPY: '复制并保存密钥',
      KEY_COPIED: '密钥复制并保存',
      CHOOSE_CATEGORY: '请选择分类',
      VALID_UNTIL: '活跃状态终止',
      CATEGORY: '分类',
    },
    TOTP_CONTAIN_SIX_DIGITS: 'TOTP 验证码必须为 6 位数字',
    SET: '安装',
  },
  CHECK_TYPES: {
    UPP_LOW_CASE_LATIN: '大小写拉丁字母',
    NUMBERS: '数字',
    SYMBOLS: "符号 {'.!@#$%^&*-'}",
    BETWEEN_CHARACTERS: '8 至 255 个字符',
  },
  EXTRA_SETTINGS: {
    TITLE: '更多”',
    SUBTITLE: 'Call center, 服务支持',
    CATEGORIES: {
      PRODUCTS: '产品',
      MAIN: '主要',
      COMMUNICATION: '联系银行',
    },
    NAV: {
      FAQ: {
        TITLE: '帮助',
        DESCRIPTION: '常见问题与解答',
        USER_GUIDE: '用户手册',
      },
      CALL_CENTER: {
        TITLE: 'Call center',
        DESCRIPTION: '7711免费服务电话',
      },
    },
  },
  MORE: {
    TITLE: '更多',
    SUB_TITLE: '联系银行',
  },
  ACCOUNT: {
    TITLE: '我的账户',
    STATUS_TITTLE: {
      OPEN: '已开启',
      CLOSED: '已关闭',
      ARRESTED: '已冻结',
      FINAL_ARRESTED: '已锁定',
    },
    CURRENT: '活期账户',
    EMPTY: '无可用账户',
    EMPTY_BY_ACCESS: '您没有付款权限，请联系管理层 "{company_name}"',
    MULTI_CURRENCY_REQUIRED: '执行此操作需要多币种账户。您可以前往银行网点开设该账户。',
    SEVERAL_ACCOUNTS_REQUIRED: '在账户之间转账,您需要开设多个结算账户。您可以前往银行网点开设额外账户。',
    ERROR: '无法获取账户信息',
    AVAILABLE_BALANCE_DETAILS: {
      TITLE: '账户详细信息',
      ACTUAL: '实际余额',
      PENDING_TOTAL: '签署中和处理中的付款总额：',
      PAYMENT_COUNT: '无付款 | {n} 笔付款 | {n} 笔付款 | {n} 笔付款',
      SIGNING_LABEL: '签署中：',
      SIGNING_LABEL_MOBILE: 'Optima Business 中签署：',
      PROCESSING_LABEL: '处理中：',
      AVAILABLE: '可用余额',
    },
  },
  DOCUMENTS: {
    TITLE: '文件',
    REQUISITES: {
      NAV: '账户信息',
      FILES: {
        FILE_ONE: {
          TITLE: '跨行转账账户信息',
          DOWNLOAD: '下载',
          SHARE: '分享',
        },
      },
      DOWNLOADING: '文件下载中',
      ERROR: '未能下载账户信息',
    },
    STATEMENT_ACCOUNT: {
      TITLE: '对账单',
      NAV: '对账单',
      DOWNLOAD_PDF: '下载 PDF 文件',
      DOWNLOAD_XLSX: '下载 Excel 文件',
      DOWNLOADING: '文件下载中',
      ORDER_FORMED: '文件生成中',
      ORDER: {
        EXTRACT: '生成对账单',
        OPTIONS: '对账单参数',
        VIEW: '视图/呈现方式',
        WITHOUT_QR_DETAILS: '无二维码交易明细',
        WITH_QR_DETAILS: '含二维码交易明细',
        MULTIPLE_CURRENCY: '可多选币种',
        DATE_FROM: '起始日期',
        DATE_TO: '截止时间',
        PERIOD_FILTER: {
          TITLE: '期间筛选',
          BY_REIMBURSEMENT: '按入账日期',
          BY_TRANSACTION_DATE: '按交易日期',
          REIMBURSEMENT_DESCRIPTION: '按入账日期 — 资金存入结算账户或银行卡的日期',
          TRANSACTION_DESCRIPTION: '按交易日期 — 支付完成的日期',
        },
      },
      STATUS: {
        IN_PROGRESS: '处理中',
        READY: '对账单已生成',
        NOT_FOUND: '指定期间无对账单数据',
        FAIL: '生成失败',
        PENDING: '待处理',
      },
      COLUMN_TABLE: {
        ACCOUNT: '账户号码',
        PERIOD: '对账单周期',
        REQUEST_DATE: '申请日期',
      },
      ALL_ACCOUNT: '全部账户',
      EMPTY: '您尚无生成的对账单。\n点击“生成对账单”进行创建',
      HAS_NOT_POS: '您尚无生成的对账单。\n点击“生成对账单”进行创建',
      ERROR: '获取对账单失败',
      ORDER_EXTRACT: {
        IN_PROCESSING: '对账单生成请求已受理',
        FAIL: '生成对账单失败',
      },
      OUTLET: {
        SELECT_ALL_OUTLET: '全部销售点',
        SELECT_ALL_POS: '全部POS终端',
        SELECT_ALL_POS_AND_KIOSKS: '全部POS + 自助终端',
        POS_NUMBER: 'POS终端编号',
      },
      RANGE_DATE: {
        TODAY: '今天',
        YESTERDAY: '昨天',
        WEEK: '周',
        MONTH: '近30天',
      },
    },
    DEVICE_STATEMENTS: {
      NAV: '设备对账单',
      DEVICE_NAME: '商户名称',
      POS_NUMBER: '设备编号（POS）',
    },
  },
  EMPLOYEES: {
    TITLE: '员工',
    SALARY: {
      SAVED_SUCCESSFULLY: '角色设置已更改',
    },
    DETAILS: {
      ACCOUNT_SETTINGS: '账户设置',
      EMPLOYEE: '用户',
      ROLE: '角色',
      ACCOUNT_NUMBER: '账户号码',
      TREATY: '合同',
      ACCOUNTS: {
        TITLE: '账户',
        SAVED_SUCCESSFULLY: '账户设置已更改',
        ACCOUNTS_EMPTY: '否',
      },
      POINT_ACCESS: {
        TITLE: '销售点访问权限',
        SUBTITLE: '管理销售点访问权限',
        ENABLE_ALL: '启用全部销售点',
        SEARCH_PLACEHOLDER: '销售点名称',
      },
    },
    LIST: {
      FULL_NAME: '姓名',
      PHONE_NUMBER: '电话号码',
      ROLE: '角色',
      DATE_OF_REGISTRATION: '注册日期',
      MISSING_EMPLOYEES: '暂无用户',
    },
    STATUS: {
      ACTIVE: '活跃',
      FREEZE: '已冻结',
    },
    ROLE: {
      CREATOR: '操作员',
      FIRST: '第一签字权',
      SECOND: '第二签字权',
      AUDITOR: '审计员',
      NONE: '无权限',
      CASH_MANAGER: '经理',
      CASHIER: '出纳员',
    },
    SETTINGS: {
      ERROR: '获取员工列表失败',
    },
  },
  IMPORTED: {
    TITLE: '已导入文件',
    FILE_NAME: '文件名',
    DATE_DOWNLOAD: '上传日期',
    CREATE_OPERATION: '创建交易',
    RETRY_UPLOAD: '重新上传文件',
    FAILED_IMPORTED: '获取导入文件失败',
    GO_OPERATION: '前往交易',
    CAUSE: '原因',
    PAYMENT_PROCESSING: '支付处理',
    STATUS_FILE: {
      PROCESSED: '已处理',
      REJECTED: '已拒绝',
      ERROR_PROCESSING: '处理时发生错误',
      PREPARING: '生成中',
      PAYMENT: {
        PROCESSING: '处理中',
        UNPROCESSABLE: '请检查文件内容',
        FAILED: '创建交易时发生错误',
        DENIED: '交易创建被拒绝',
        UPLOADING: '正在创建交易..',
        UPLOADED: '交易已创建',
        EDITED: '此交易已被编辑',
        ERROR_UPLOADING: '创建交易时出错',
        PARTIALLY_PROCESSED: '部分处理',

        FILE_VALIDATION_PROCESSING: '正在检查清单…',
        FILE_VALIDATION_FINISHED: '工资单无误',
        FILE_VALIDATION_ERROR: '请检查数据',
        BUSINESS_VALIDATION_PROCESSING: '正在核对明细信息…',
        BUSINESS_VALIDATION_FINISHED: '明细信息无误',
        BUSINESS_VALIDATION_ERROR: '请核对扣款账户和入账账户',
        SALARY_CREATION_PROCESSING: '正在生成清单',
        SALARY_CREATION_FINISHED: '已生成工资单和支付指令',
        SALARY_CREATION_ERROR: '出错了，请重试',
        ERROR_CONFIRMED: '已归档',
        PROCESSING_COMPLETED: '待签署',
      },
      SALARY: {
        PROCESSING: '处理中',
        UNPROCESSABLE: '无法处理支付',
        FAILED_PREPARING: '生成时尝试失败',
        ERROR_PREPARING: '生成时出错',
        READY_FOR_EXECUTION: '待执行',
      },
    },
    STATUS_PAYMENT: {
      OK: '已处理',
      REJECTED: '已拒绝',
    },
    EMPTY: '无文件',
    CHOOSE_FILE_TYPE: {
      TITLE: '请选择所需类型',
      LABEL: '请为金额低于或等于100万索姆的跨行转账选择类型',
    },
    WARNING: "金额超过100万索姆的转账将自动以'大额'类型发送",
  },

  PAYMENT: {
    TITLE: '支付',
    FOR_SIGN: '待签署付款',
    NO_ACCESS_OPERATION: {
      TITLE: '没有找到需要的账户？',
      DESCRIPTION: '您没有访问权限。请联系第一签署人为您授予权限。',
      MANAGER_HINT: '管理者如何授予权限：',
      STEPS: '设置 → 员工 → 选择相应员工 → 选择相应账户 → 打开所需操作的开关。',
    },
    TYPE: {
      CLEARING: '清算',
      GROSS: '大额',
      CLEARING_GROSS: '清算/大额',
      SWIFT: 'SWIFT',
      INTRABANK_TRANSFER_OWN: '本人账户间转账',
      INTRABANK_TRANSFER_FOREIGN: '转至其他客户账户',
      INTRABANK_TRANSFER_RKO_2_CARD_OWN: '转账至商务卡',
      RKO_2_BUSINESS_CARD_OWN: '转账至商务卡',
      RKO_2_BUSINESS_CARD_FOREIGN: '转至OPTIMA24',
      RKO_2_INDIVIDUAL_CARD_FOREIGN: '转至OPTIMA24',
      RKO_2_INDIVIDUAL_CARD_OWN: '转至OPTIMA24',
      BUSINESS_CARD_2_RKO_OWN: '从商务卡转至结算账户',
      BUSINESS_CARD_2_RKO_FOREIGN: '从商务卡转至结算账户',
      INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_OWN: '从商务卡转至其他本人结算账户',
      INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_FOREIGN: '从商务卡转至其他结算账户',
      CONVERSION: '货币兑换',
      BUDGET_PAYMENT: '预算支付',
      REFUND: '二维码支付退款',
      TRANSFER_BY_INVOICE: '支付账单',
      QR: '二维码支付/转账',
      NO_TITLE: '无名称',
      BETWEEN_ACCOUNTS: '本人账户间转账',
      INTRABANK_TRANSFER: '行内转账',
      VIEW_ACCOUNT: '查看账户',
      VIEW_LOAN_CLAIM: '查看贷款信息',
      SALARY: '工资项目',
    },
    ORIGIN: {
      ALL: '全部',
      MANUAL: '自定义',
      FILE: '已导入的',
      DIRECT_BANK: '1C',
    },
    NOTIFICATIONS: {
      MESSAGE: {
        ERROR: {
          TITLE: '付款 <span class="text-primary">银行已拒绝</span>',
          TITLE_TEXT: '支付被银行拒绝',
          TEXT: '"{operationCode}" 编号{transferNum} 金额{ {amount} {currency}',
        },
        PAYMENT_REQUEST_TO_BANK: {
          TITLE: '付款 <span class="text-primary">银行已拒绝</span>',
          TITLE_TEXT: '支付被银行拒绝',
          TEXT: '"{operationCode}" 编号{transferNum} 金额 {amount} {currency} \n( {text} )支付被银行拒绝',
        },
      },
    },
    TEMPLATES: {
      TITLE: '模版',
      NAME: '模板名称',
      SEARCH: '模版搜索',
      CREATED: '模版已保存',
      EDIT: '编辑模版',
      EDITING: '模板编辑',
      EDITED: {
        SUCCESS: '模版已编辑',
        ERROR: '编辑模版失败',
      },
      DELETE: '删除模板',
      DELETED: '模版已删除',
      NOT_FOUND: '未找到模版',
      CREATE: '创建模版',
    },
    DIALOG: {
      EXIT: {
        TITLE: '您确定要退出支付流程？',
        LABEL: '如现在退出，所已输入的数据可能会丢失',
      },
    },
  },
  STATEMENT: {
    TRANSACTION: {
      DATE: {
        TODAY: '当日',
        TODAY_TIME: '当日 {time} 点',
        YESTERDAY: '昨天',
        YESTERDAY_TIME: '昨天 {time} 点',
      },
      EMPTY: {
        SUCCESS: '无已完成交易',
        ON_SIGN: '无待签署交易',
        REJECTED: '无被拒绝交易',
        ERROR: '无被银行拒绝的交易',
        FOR_EDITING: '无待编辑的交易',
        DRAFT: '您的草稿列表为空',
      },
      EMPTY_STATEMENT: '交易列表为空',
      DELETE: '删除',
      DOWNLOAD: '下载为PDF',
      DOWNLOAD_STATEMENT: '下载对账单',
      SCHEME: '显示示意图',
      GET: '下载',
      OPEN: '打开',
      EDIT: '编辑',
      EDIT_ALL: '全部编辑',
      CHANGE: '编辑',
      REPEAT: '重复',
      REVOKE: '拒绝',
      REVOKE_ALL: '全部拒绝',
      SIGN: '签署付费',
      SIGN_ALL: '全部签署',
      SEND_FOR_SIGN: '发送签署',
      SEND_AFTER_CHANGE: '提交签署',
      RECALL: '撤回',
      PRINT: '打印',
    },
    TRANSFER_ACTIONS: {
      DELETE: '删除付款',
      EDIT: '编辑付款',
      EDITING: '付款编辑',
      CHANGE: '编辑',
      REPEAT: '重复付款',
      REVOKE: '拒绝付款',
      SIGN: '签署付款',
      TITLE: '付款详情',
      FOR_SIGN: '待签署',
      RECALL: '撤回',
    },
    NOTIFICATIONS: {
      TITLE: '对账单',
      TITLE_MANY: '对账单列表',
      OK: '确定',
      GO_ON: '前往',
      MESSAGE: {
        READY: '对账单已生成',
        FAIL: '生成失败',
        NOT_FOUND: '指定期间内无对账单数据',
        MANY_STATEMENT: '申请已生成',
      },
    },
    DIALOG: {
      FAIL: '对账单未生成',
    },
  },
  EXCHANGE_RATES: {
    ALL_RATES: '所有汇率',
    PURCHASE: '买入',
    SALE: '卖出',
    FOR: '于',
    RATES_LOADING_ERROR: '汇率加载失败，请尝试刷新页面',
    CASH: '现钞汇率',
    CASHLESS: '转账汇率',
    CARD: '卡汇率',
    NBKR: '吉尔吉斯共和国国家银行汇率',
    RATES: '汇率',
    ALL_EXCHANGE_RATES: '所有货币汇率',
  },
  SIGNATORIES: {
    MANY_SIGNATORY: '签署人',
    PRIMARY_SIGNATURE: '第一签名',
    SECONDARY_SIGNATURE: '第二签名',
    PROCESSING_SIGNATURE: '待签署',
    ON_VERIFICATION_COMPLETED: '已签署',
    PARTIAL_CONFIRMATION_COMPLETED: '已签署',
    CANCELED_SIGN_ONE: '已拒绝',
    CANCELED_SIGN_TWO: '已拒绝',
    FOR_EDITING: '已拒绝',
    REVOKE: '已撤回',
    ON_CONFIRMATION_COMPLETED: '已发送至银行',
  },
  FILTER_HISTORY: {
    FILTER: '删选',
    SEARCH: '搜索',
    PURPOSE: '付款用途',
    PAYMENT_TYPE: '付款类型',
    PAYMENT_ORIGIN: '来源',
    DATE_FROM: '起始日期',
    DATE_TO: '截止日期',
    AMOUNT_FROM: '起始金额',
    AMOUNT_TO: '截止金额',
    APPLY: '应用',
    RESET: '重置',
    WITH: '自 {value}',
    BEFORE: '至 {value}',
    RULE_AMOUNT: '起始金额不能大于截止金额',
    RULE_THREE_MONTH_PERIOD: '请选择不超过 3 个月的期间',
    ASCENDING: '按升序',
    DESCENDING: '按降序',
    BY_DEADLINE: '按期限',
    BY_TOTAL: '按金额',
    BY_QR_TYPE: '按二维码类型',
    BY_QR_TRANSACTION_TYPE: '按交易类型',
  },
  NOTIFICATION: {
    READ_ALL: '全部已读',
    TITLE: '通知',
    EMPTY: '暂无通知',
  },
  RECAPTCHA: {
    TEXT: '本网站受reCAPTCHA和Google保护',
    AND: '及',
    PRIVACY_POLICY: '隐私政策',
    TERMS_OF_SERVICE: '服务条款',
  },
  ERRORS: {
    AUTH: {
      OTP_INCORRECT: 'TOTP验证码错误',
      PERMANENT_LOCKOUT_EXCEPTION: '用户被锁定',
      USER_CREDENTIALS_EXCEPTION: '客户ID或密码错误',
      PHONE_ALREADY_EXISTS: '电话号码不正确',
      USER_STATE_INCORRECT: '您尚未完成首次注册。无法重置密码。',
      UNKNOWN: '错误！请稍后重试',
    },
    PAYMENT: {
      SWIFT_RSBANK_EXCEPTION: '由于代理行的内部政策，无法向所选银行转账',
      ACCOUNT_DEBIT_NOT_FOUND: '未找到扣款账户.',
      ACCOUNT_CREDIT_NOT_FOUND: '未找到收款人账户.',
      OPERATION_NOT_ALLOWED: '禁止此类操作',
      ACCOUNT_NOT_ACCESSIBLE: '您无法访问该账户',
      ACCOUNT_DEBIT_CLOSED_OR_SEIZED: '扣款账户已关闭或冻结',
      ACCOUNT_CREDIT_CLOSED_OR_SEIZED: '收款人账户已关闭或冻结',
      INVALID_OPERATION_TYPE: '无法对此账户进行此类操作',
      INSUFFICIENT_FUNDS: '账户余额不足',
      CURRENCY_MISMATCH_FOR_CONVERSION: '进行兑换需选择不同货币的账户。',
      INVALID_PAYMENT_TYPE_FOR_INTERNAL_ACCOUNT: '无法对行内账户使用此类付款类型。',
      CURRENCY_MISMATCH_BETWEEN_ACCOUNTS: '扣款账户货币与收款人账户货币不符',
      INVALID_OPERATION_FOR_YOUR_COMPANY: '向您法人实体的账户转账，请选择其他操作类型',
      INVALID_OPERATION_FOR_OTHER_COMPANY: '向其他法人实体的账户转账，请选择其他操作类型',
      ACCOUNT_NOT_ASSOCIATED_WITH_LEGAL_ENTITY: '账户不属于法人实体',
      BLOCKED_OR_NON_ASSOCIATED_EMPLOYEE: '员工已被封锁或不属于该公司',
      OPERATION_NOT_AVAILABLE_IN_CURRENCY: '该操作类型不支持外币',
      INVALID_REQUISITE_EXCEPTION: '通过卡账号向Elkart转账不可用',
      INVALID_CARD_TYPE_CODE_EXCEPTION: '向Elkart Business卡转账不可用',
      CHECK_RU_CITIZEN_EXCEPTION: '根据代理行限制，欧元转账暂不可用',
      INVOICE_NOT_FOUND: '未找到付款账单',
      WRONG_INVOICE_TYPE: '账单类型无效',
      WRONG_INVOICE_STATE: '当前状态下无法修改账单',
      INVOICE_IS_PAID: '账单已支付，无法取消',
      CLIENT_NOT_FOUND: '未找到客户',
      RECIPIENT_NOT_FOUND: '未找到发送方或账户号码',
      PAYER_EXCEPTION: '付款方和收款方不能相同',
      PAYER_NOT_EMPTY_EXCEPTION: '外部账单无需填写付款方',
      ELQR_NOT_CREATED: '无法生成二维码',
      WRONG_DETAIL_AMOUNT: '商品总价与单价和数量不一致',
      WRONG_AMOUNT: '账单总金额与商品总金额不一致',
      ALREADY_EXISTS_EXCEPTION: '该名称的商品/服务已存在',
      OPERATION_NOT_VALID_EXCEPTION: '该账单已存在付款',
      INVALID_INVOICE_STATE: '当前状态下无法为该账单创建付款',

      CHECK_FIELD_FOR_NULL_EXCEPTION: '付款中缺少部分数据，请检查文件。',
      FILE_NOT_FOUND_EXCEPTION: '缺少该文件',
      FILE_PREPARE_TO_CREATE_EXCEPTION: '准备创建时出错',
      FILE_REPEAT_EXCEPTION: '重新处理时出错：仅可重试状态为‘处理错误’的文件',
      FILE_STATE_MISMATCH_EXCEPTION: '创建付款时出错：仅可从状态为‘已处理’、‘失败’、‘上传错误’的文件创建付款',
      FILE_SIZE_EXCEPTION: '文件大小超出允许值',
      FILE_EXTENSION_EXCEPTION: '文件扩展名不符合预期',
      DUPLICATE_PAYMENT_IN_IMPORTED_FILE_EXCEPTION: '文件中存在重复付款：请检查/修改数据',
      CANT_DETERMINE_ORGANIZATION_EXCEPTION: '出错，需联系银行网点',
      DOCUMENT_NUMBER_ALREADY_EXISTS_EXCEPTION: '当前付款委托号已被使用，请使用唯一编号',
      FORBIDDEN_EXCEPTION: '错误，访问被禁止',
      NOT_ALLOWED_DELETE_OPERATION: '无法删除，需要向银行致函',
      PROCESS_ALREADY_EXISTS_EXCEPTION: '错误：该操作正在处理中',
      RULE_EXCEPTION: '错误。请检查输入数据的正确性',
      ACTIVITI_PROCESS_ALREADY_EXISTS_EXCEPTION: '错误，付款已存在',
      INTRA_AND_INTER_BANK_BIC_CORRESPONDENCE_EXCEPTION:
        '银行代码与账户不符。（若为向过渡账户入账，请确保您的账户与过渡账户属于同一分支机构）',
      INTERBANK_INVALID_CURRENCY_EXCEPTION: 'Clearing/Gross不允许的货币',
      INTERBANK_SAME_BIC_CODES_EXCEPTION: 'Clearing/Gross不允许的BIC',
      INTRA_AND_INTERBANK_BBAN_ACCOUNT_STRUCTURE_EXCEPTION: '收款人账户错误.',
      INTRA_AND_INTERBANK_SAME_ACCOUNT_EXCEPTION: '错误，发送方与收款人账户不能为同一账户',
      INTRABANK_DIFFERENT_BIC_CODES_EXCEPTION: 'BIC不允许进行行内付款',
      INVALID_VALUE_DATE_EXCEPTION: '错误，不能选择过去的日期',
      NOT_WORKING_DAY_FOR_VALUE_DATE_EXCEPTION: '错误，所选起息日为非工作日',
      SWIFT_INVALID_EXOTIC_CURRENCY_EXCEPTION: 'SWIFT不允许的异币种货币',
      FILE_READING_EXCEPTION: '读取文件时出错。文件内容不符合预期.',

      INVALID_PAYER_BANK_EXCEPTION: '未找到付款人银行BIC',
      INVALID_RECIPIENT_BANK_EXCEPTION: '未找到收款人银行BIC',
      INVALID_PAYMENT_CODE_EXCEPTION: '未找到付款代码',
      LEGAL_PARTY_ID_CANT_BE_NULL_EXCEPTION: '缺少公司ID',
      PAYER_ACCOUNT_CANT_BE_NULL_EXCEPTION: '缺少扣款账户',
      PAYER_BIC_CANT_BE_NULL_EXCEPTION: '缺少付款人BIC',
      PAYER_NAME_CANT_BE_NULL_EXCEPTION: '缺少付款人名称',
      PAYER_AMOUNT_CANT_BE_NULL_EXCEPTION: '缺少扣款金额',
      PAYER_CURRENCY_CANT_BE_NULL_EXCEPTION: '缺少扣款货币数据',
      RECIPIENT_ACCOUNT_CANT_BE_NULL_EXCEPTION: '缺少入账账户',
      RECIPIENT_BIC_CANT_BE_NULL_EXCEPTION: '缺少收款人BIC',
      RECIPIENT_NAME_CANT_BE_NULL_EXCEPTION: '缺少收款人名称',
      RECIPIENT_AMOUNT_CANT_BE_NULL_EXCEPTION: '缺少入账金额',
      RECIPIENT_CURRENCY_CANT_BE_NULL_EXCEPTION: '缺少付款货币',
      AMOUNT_CANT_BE_NULL_EXCEPTION: '缺少付款金额',
      CURRENCY_CANT_BE_NULL_EXCEPTION: '缺少付款货币',
      PURPOSE_CANT_BE_NULL_EXCEPTION: '缺少付款用途',
      COMMISSION_ACCOUNT_CANT_BE_NULL_EXCEPTION: '缺少手续费支付账户',
      COMMISSION_CURRENCY_CANT_BE_NULL_EXCEPTION: '缺少手续费账户货币',
      COMMISSION_OPTION_CANT_BE_NULL_EXCEPTION: '缺少计费数据',
      IS_EXOTIC_CANT_BE_NULL_EXCEPTION: '缺少异币种金额数据',
      EXOTIC_AMOUNT_CANT_BE_NULL_EXCEPTION: '缺少一笔中金额数据',
      EXOTIC_RATE_CANT_BE_NULL_EXCEPTION: '缺少异币种汇率数据',
      EXOTIC_CURRENCY_CANT_BE_NULL_EXCEPTION: '缺少异币种货币',
      RUB_CODE_VO_CANT_BE_NULL_EXCEPTION: '缺少VO代码',
      RUB_INN_CANT_BE_NULL_EXCEPTION: '缺少纳税人识别码（俄罗斯卢布）',
      KZT_BIN_CANT_BE_NULL_EXCEPTION: '缺少银行代码',
      KPP_CANT_BE_NULL_EXCEPTION: '缺少纳税人登记原因代码',
      VALUE_DATE_CANT_BE_NULL_EXCEPTION: '缺少起息日',
      OPERATION_CANT_BE_NULL_EXCEPTION: '缺少操作',
      PAYER_INN_CANT_BE_NULL_EXCEPTION: '缺少付款人纳税人识别码',
      PAYMENT_CODE_CANT_BE_NULL_EXCEPTION: '缺少付款代码',
      RUB_CODE_VO_MUST_BE_NULL_EXCEPTION: 'VO代码不存在',
      RUB_INN_MUST_BE_NULL_EXCEPTION: '纳税人识别码（卢布）不应存在',
      KZT_BIN_MUST_BE_NULL_EXCEPTION: '银行识别不应存在',
      KPP_MUST_BE_NULL_EXCEPTION: '纳税人登记原因代码不应存在',
      EXOTIC_AMOUNT_MUST_BE_NULL_EXCEPTION: '异币种金额不应存在',
      EXOTIC_RATE_MUST_BE_NULL_EXCEPTION: '异币种汇率不应存在',
      EXOTIC_CURRENCY_MUST_BE_NULL_EXCEPTION: '异币种货币不应存在',
      INSUFFICIENT_FUNDS_EXCEPTION: '付款金额超出账户可用余额',

      CELL_VALUE_DATE_IS_EMPTY: '请在相应单元格内填写日期',
      CELL_VALUE_DATE_DATA_IS_INVALID_WORKING_DAY: '起息日不能为节假日',
      CELL_VALUE_DATE_DATA_IS_INVALID_TIME: '已超时，请改日再试',
      CELL_VALUE_DATE_DATA_IS_INVALID_DATE: '起息日只能是当日',
      CELL_LEGAL_PARTY_ID_IS_EMPTY: "请填写'公司ID栏",
      CELL_COMPANY_NAME_IS_EMPTY: "请填写'公司名称栏",
      CELL_ACCOUNT_IS_EMPTY: '请在相应单元格内填写中转账户栏',
      CELL_AMOUNT_IS_EMPTY: "总金额'一栏为空",
      CELL_COMMISSION_IS_EMPTY: "请填写'银行手续费栏",
      CELL_TOTAL_AMOUNT_IS_EMPTY: "最终金额'一栏为空",
      CELL_CURRENCY_IS_EMPTY: "请填写'货币'栏",
      CELL_FORMULA_TOTAL_AMOUNT_IS_EMPTY: "计算金额'一栏为空",
      DETAILS_CELL_CARD_ACCOUNT_IS_EMPTY: "请填写'员工账户栏",
      DETAILS_CELL_AMOUNT_IS_EMPTY: '请在相应单元格内填写员工入账金额栏',
      DETAILS_CELL_EMPLOYEE_NAME_IS_EMPTY: "请填写'员工姓名'栏",
      CELL_VALUE_DATE_INVALID_FORMAT: "日期信息单元格的必填格式为'短日期格式",
      CELL_LEGAL_PARTY_ID_INVALID_FORMAT: "公司ID信息单元格的必填格式为'常规/文本",
      CELL_COMPANY_NAME_INVALID_FORMAT: "公司名称信息单元格的必填格式为'常规/文本",
      CELL_ACCOUNT_INVALID_FORMAT: "账户信息单元格的必填格式为'常规/文本'",
      CELL_AMOUNT_INVALID_FORMAT: "总金额信息单元格的必填格式为'常规/数值",
      CELL_COMMISSION_INVALID_FORMAT:
        "银行手续费信息单元格的必填格式为'常规/数值'。文件中金额小数部分最多允许2位数字。",
      CELL_TOTAL_AMOUNT_INVALID_FORMAT: "最终金额信息单元格的必填格式为'常规/数值",
      CELL_CURRENCY_INVALID_FORMAT: "货币信息单元格的必填格式为'常规/文本",
      CELL_FORMULA_TOTAL_AMOUNT_INVALID_FORMAT: "计算金额信息单元格的必填格式为'常规/数值",
      DETAILS_CELL_CARD_ACCOUNT_INVALID_FORMAT: "员工账户信息单元格的必填格式为'常规/文本",
      DETAILS_CELL_AMOUNT_INVALID_FORMAT:
        "员工入账金额信息单元格的必填格式为'常规/数值'。文件中金额小数部分最多允许2位数字。",
      DETAILS_CELL_EMPLOYEE_NAME_INVALID_FORMAT: "员工姓名信息单元格的必填格式为'常规/文本",
      CELL_VALUE_DATE_DATA_IS_INVALID: '起息日只能是当日',
      CELL_ACCOUNT_DATA_IS_INVALID: '扣款结算账户的必填格式：16位数字，109#############',
      CELL_CURRENCY_DATA_IS_INVALID: '允许的货币：吉尔吉斯索姆/美元',
      DETAILS_CELL_CARD_ACCOUNT_DATA_IS_INVALID: '员工卡账户的必填格式：16位数字，109#############',
      DETAILS_CELL_AMOUNT_DATA_IS_INVALID: '员工入账金额不能为负值',
      DETAILS_LIST_IS_EMPTY: '员工列表为空',
      INVALID_SALARY_TOTAL_AMOUNT_SUM: "入卡账户金额'与员工入账清单的计算金额不符",
      INVALID_SALARY_AMOUNT_COMPARISON: "入卡账户金额'与'计算金额'不符",
      INVALID_SALARY_TOTAL_AMOUNT_CALCULATION: '包含手续费的最终金额计算错误（请使用模板中的公式）',
      SALARY_DETAIL_DUPLICATE_EXCEPTION: '发现员工账户重复',
      //FORBIDDEN_EXCEPTION: 'Ведомость не принадлежит к текущей организации.',
      SALARY_DUPLICATE_EXCEPTION: '当前文件名已被使用',
      ERROR: '处理工资单时发生错误。请重试',
      SUCCESS: '文件上传成功',
      ACCOUNT_ERROR: '账户未找到',
      CURRENCY_ERROR: '未找到所选货币的账户。请检查后重试',
      SUM_ERROR: '原因：最终金额不正确',
      CONTRACT_NOT_FOUND_ERROR: '合同未找到。',
      OPERATION_DATE_ERROR: '原因：相关日期操作日已结束',
      BALANCE_IS_LESS_AMOUNT_ERROR: '原因：账户余额不足',
      ACCOUNT_DIFF_ERROR: '企业账户与工资单中的账户不符',
      EMPLOYEE_ACCOUNT_ERROR: '员工账户不存在',
      EMPLOYEE_CURRENCY_ERROR: '员工账户货币与工资单记录不符',
      FULL_NAME_ERROR: '工资单中的员工姓名与系统中姓名不符',
      EMPLOYEE_NOT_FOUND: '合同中未找到该员工',

      EMPLOYEE_STATE_ERROR: '合同中未找到该员工',
      EMPLOYEE_CARD_STATE_BLOCKED: '员工卡账户已被冻结。请联系分行',
      EMPLOYEE_CARD_STATE_CLOSED: '员工卡账户已关闭。请联系分行',
      EMPLOYEE_CARD_STATE_ERROR: '员工卡账户存在问题。请联系分行',

      CELL_LEGAL_PARTY_ID_DATA_IS_INVALID: '错误：公司代码无效。请确认输入的公司标识正确并重试',
      CLEARING_CREATION_DEADLINE_EXCEPTION: '创建清算的时间已截止。请选择其他起息日',
      CLEARING_SIGNING_DEADLINE_EXCEPTION: '签署清算的时间已截止。请选择其他起息日',
      GROSS_CREATION_DEADLINE_EXCEPTION: '创建大额转账的时间已截止。请选择其他起息日',
      GROSS_SIGNING_DEADLINE_EXCEPTION: '签署大额转账的时间已截止。请选择其他起息日',
      INTRA_OWN_CREATION_DEADLINE_EXCEPTION: '创建行内本人账户转账的时间已截止。请选择其他起息日',
      INTRA_OWN_SIGNING_DEADLINE_EXCEPTION: '签署行内本人账户转账的时间已截止。请选择其他起息日',
      INTRA_FOREIGN_CREATION_DEADLINE_EXCEPTION: '创建行内他人账户转账的时间已截止。请选择其他起息日',
      INTRA_FOREIGN_SIGNING_DEADLINE_EXCEPTION: '签署行内他人账户转账的时间已截止。请选择其他起息日',
      CONVERSION_CREATION_DEADLINE_EXCEPTION: '创建货币兑换的时间已截止。请选择其他起息日',
      CONVERSION_SIGNING_DEADLINE_EXCEPTION: '货币兑换的签署时间已截止。请选择其他起息日',
      SWIFT_CREATION_DEADLINE_EXCEPTION: '创建SWIFT系统转账的时间已截止。请选择其他起息日',
      SWIFT_SIGNING_DEADLINE_EXCEPTION: '签署SWIFT系统转账的时间已截止。请选择其他起息日',
      SALARY_CREATION_DEADLINE_EXCEPTION: '创建工资支付的时间已截止。请选择其他起息日',
      SALARY_SIGNING_DEADLINE_EXCEPTION: '签署工资支付的时间已截止。请选择其他起息日',
      CREATION_DEADLINE_EXCEPTION: '创建操作的时间已截止。请选择其他起息日',
      SIGNING_DEADLINE_EXCEPTION: '创建操作的时间已截止。请选择其他起息日',

      ACCOUNT_CREDIT_NOT_FOUND_EXCEPTION: '未找到指定货币的收款人账户',
      OPERATION_NOT_ALLOWED_EXCEPTION: '所选操作类型对指定账户禁止',
      ACCOUNT_NOT_ACCESSIBLE_EXCEPTION: '账户禁止查看',
      ACCOUNT_DEBIT_CLOSED_OR_SEIZED_EXCEPTION: '扣款账户不可用',
      ACCOUNT_CREDIT_CLOSED_OR_SEIZED_EXCEPTION: '充值账户不可用',
      INVALID_OPERATION_TYPE_EXCEPTION: '无法通过所选账户进行当前操作',
      CURRENCY_MISMATCH_FOR_CONVERSION_EXCEPTION: '兑换账户必须是多货币账户',
      INVALID_PAYMENT_TYPE_FOR_INTERNAL_ACCOUNT_EXCEPTION: '无法向行内账户执行付款',
      CURRENCY_MISMATCH_BETWEEN_ACCOUNTS_EXCEPTION: '扣款账户货币与收款人账户货币种类不符',
      INVALID_OPERATION_FOR_YOUR_COMPANY_EXCEPTION: '账户归属于同一法人企业',
      ACCOUNT_NOT_ASSOCIATED_WITH_LEGAL_ENTITY_EXCEPTION: '收款人账户不属于该法人企业',
      INVALID_OPERATION_FOR_OTHER_COMPANY_EXCEPTION: '账户不属于法人企业',
      BLOCKED_OR_NON_ASSOCIATED_EMPLOYEE_EXCEPTION: '非员工或已被冻结',
      OPERATION_NOT_AVAILABLE_IN_CURRENCY_EXCEPTION: '无法通过指定账户以所选货币进行操作',

      PACKAGE_TIME_OUT_EXCEPTION: '该分期期限类型不可用，请尝试为其他期限创建二维码',
      PARTNER_DICTIONARY_EXCEPTION: '您没有与此产品交互的必要权限。如需开通产品，请联系我们',
      InstallmentForbiddenException:
        '您没有查看和与此模块交互的必要权限。请联系贵公司负责权限管理的相关人员以获取所需许可',
      ACTIVITY_TIMEOUT_EXCEPTION: '未能找到合作伙伴或网点的有效参数，请重试',

      USER_HAS_ROLE_EXCEPTION: '用户已拥有此角色',
      USER_EXCEPTION: '账户已绑定至其他手机号码',
      EMPTY_PIN_EXCEPTION: 'PIN个人鉴别号码/INN纳税人识别码输入不正确：PIN个人鉴别号码/INN纳税人识别码不能为空',
      WRONG_FIRST_NUM_EXCEPTION: '个人鉴别码/纳税人识别码输入不正确：第一位数字必须以1或2开头',
      WRONG_PIN_DATE_EXCEPTION: 'PIN个人鉴别号码/纳税人识别码输入不正确：请检查输入数据',
      WRONG_PIN_POSITION: '个人鉴别码/纳税人识别码输入不正确：第9位数字不能为1和5',
      TASK_REJECTED_EXCEPTION: '使用该纳税人识别码创建分期销售商的申请正在处理中，请等待申请完成',
      PRODUCT_ROLE_POLICY_EXCEPTION: '用户缺少执行此操作的身份权限',
      NOT_FOUND_ROLE_EXCEPTION: '抱歉，未找到角色，请稍后重试',
      DUPLICATE_TASK_EXCEPTION: '使用该纳税人识别码创建分期销售商的申请正在处理中，请等待申请完成',
      CONTRACT_NOT_STARTED_EXCEPTION: '与合作伙伴的合同生效起始日尚未到达。请根据已签订条款等待合同生效起始日',
      ILLEGAL_ARGUMENT_EXCEPTION: '输入的号码不正确。请检查并重新输入',
      LIMIT_BLOCKED_EXCEPTION: '仅可向贵公司的员工转账',
      LIMIT_BLOCKED_EXCEPTION_WHITE_LIST: '暂时无法发送签署——但该功能即将开放',
      UNSUPPORTED_TYPE_OF_ACCOUNT_FOR_OPERATION_EXCEPTION: '向Elkart卡和活期账户的退款暂不可用',
      NOT_FOUND: '@:SHARED.RULE.CLIENT_NOT_FOUND',
      UNKNOWN: '错误！请稍后重试',
      KNOWN: '错误！请稍后重试',
    },

    OFFLINE: '网络连接中断',
    DOCUMENT_TEMPLATE: {
      FORBIDDEN_EXCEPTION: '访问被禁止',
      LARGE_DOC_NOT_FOUND_EXCEPTION: '文件未找到',
      LARGE_DOC_ALREADY_EXISTS_EXCEPTION: '具有指定参数的文档已存在',
      LARGE_DOC_DOWNLOAD_NOT_ALLOWED_EXCEPTION: "无法下载文件，因其状态非'就绪",
      NOT_FOUND_QR_PAYMENT: '所选时段无数据 \n 请尝试更改日期后再试一次。',
      UNKNOWN: '错误。请稍后重试',
    },
    PAY_LOGIC: {
      ACTION_ERROR: '执行操作时发生错误。请重试',
      NOT_FOUND: '请求的数据未找到。请检查输入的数据并重试',
      NO_DEBTS: '无欠款。所有账单已支付',
      PROVIDER_ANSWER_ERROR: '服务提供商响应错误。请稍后再试',
      SERVICE_BLOCKED_ERROR: '服务已封锁。请联系支持获取更多信息',
      SERVICE_ERROR: '服务运行发生错误。请稍后再试',
      SYSTEM_ERROR: '发生系统错误。请稍后再试',
      VALIDATION_ERROR: '数据验证错误。请检查输入的数据并重试',
      UNKNOWN: '错误。请稍后再试',
    },
    OUTLET: {
      UNKNOWN: '错误。请稍后再试',
      KNOWN: '错误。请稍后再试',
      CASHIER_HAS_ACTIVE_SHIFT_EXCEPTION: '收银员在销售点{salePointName}的收银机{cashCode}上已接班',
      CASHIER_HAS_ACTIVE_SHIFT_EXCEPTION_HINT: '请收银员完成交接后以便删除',
      DUPLICATE_SALE_POINT_NAME_EXCEPTION: '已存在同名称的销售点',
      ACCOUNT_SAVING_EXCEPTION: '未能保存账单。请重试',
      ACCOUNT_SAVING_IN_ACQUIRING_EXCEPTION: '未能保存账单。请重试',
      CASHIER_HAS_OPEN_SHIFT_EXCEPTION: '收银员未关闭当前班次。请关闭后再继续',
      ENTITY_NOT_FOUND_EXCEPTION: '未能找到数据，请重试',
      FILE_NOT_FOUND_EXCEPTION: '未能找到数据，请重试',
      SALE_POINT_EDIT_FORBIDDEN_EXCEPTION: '销售点配有收银机。要修改数据，需先删除收银机后才能继续操作',
      TAX_ATTRIBUTE_SAVING_EXCEPTION: '请指定税务部门和销售点坐标以继续',
    },
    STATEMENT: {
      PERIOD_IS_LIMITED_BY_1_YEAR: '下载对账单的最长期限为1年',
      UNKNOWN: '生成对账单失败',
    },
  },
  LOAN_CLAIMS: {
    TITLE: '贷款',
    SOON: '贷款即将上线',
  },
  QR_CODE: {
    CREATE_QR: '生成二维码',
    MY_QR_CODE: '我的二维码',
    RECEIVING_FUNDS: '"接受任意银行付款',
    TITLE: '二维码',
    SELECT_ACCOUNT: '入账账户',
    COMMISSION: '收款手续费0/2%',
    DOWNLOAD: '下载二维码',
    PRINT: '打印二维码',
    BLACK_AND_WHITE_A4: '黑白A4',
    BLACK_AND_WHITE_A5_A6: '黑白A5A6',
    COLOR_A4: '彩色A4',
    COLOR_A5_A6: '彩色A5A6',
    SAVE_CHANCE: '保存更改',
    CANCEL_CHANCE: '取消更改',
    EMPTY_CARD: '无账户无卡',
    OPEN_ACCOUNT_CARD: '在Optima Bank网点开立结算账户或Visa商务卡',
    SHARE: '分享',
    CARD_ACCOUNTS: '银行卡账户',
    SETTLEMENT_ACCOUNTS: '结算账户',
    NO_ACCESS_ACCOUNT: '无账户访问权限',
    GET_ACCESS: '请联系管理层获取访问权限',
    NO_CARD: '无卡',
    OPEN_CARD: '请联系管理层获取访问权限',
    FORBIDDEN: '无收款点账户访问权限',
    GET_ACCESS_SALE: '请联系公司所有者获取访问权限',
    OPEN_ACCESS: '开启账户访问权限：‘设置’→‘用户’→选择员工→选择结算账户→启用‘创建二维码',
    ON_ACCOUNT: '到账户',
    ON_SALE_POINT: '到收款点',
    EMPTY_SALE_POINT: '在创建二维码前，请添加销售点',
    ASK_SALE_POINT: '在创建二维码前需要求负责人添加销售点',
    TAB_SALE_POINT: '销售点二维码',
    TAB_PERSONAL: '个人二维码',
    PURPOSE: '用途',
    PURPOSE_HINT: '可在用途中说明付款事由或收款对象',
    ALLOW_EDIT_AMOUNT: '允许修改金额',
    ALLOW_EDIT_AMOUNT_HINT: '开启后，付款人可修改您填写的金额',
    WITH_PURPOSE_TITLE: '带用途和\n指定金额的二维码',
    WITH_PURPOSE_SUBTITLE: '为每位客户或每项服务\n创建专属二维码',
    WITH_PURPOSE_ITEM_TITLE: '付款用途',
    WITH_PURPOSE_ITEM_TEXT: '您可为客户创建二维码，并注明付款用途：为何付款、为谁付款、金额多少',
    NO_MANUAL_INPUT_TITLE: '无需手动输入即可付款',
    NO_MANUAL_INPUT_TEXT: '客户扫码后，系统将自动生成付款',
    HISTORY_TITLE: '付款历史',
    HISTORY_TEXT: '在付款历史中可看到您填写的用途，并清楚了解款项对应的支付内容',
    WHAT_IS_PERSONAL_QR: '什么是个人二维码？',
  },
  CARD: {
    TITLE: '卡',
    BLOCK: '卡被冻结',
    SETTINGS: '设置',
    HISTORY: '历史记录',
    LIMIT: '限额',
    LIMIT_TITLE: '选择限额类型',
    BLOCK_PAYMENT_CARD: '您将锁定银行卡',
    ARRESTED: '解锁',
    FINAL_ARRESTED: '已锁定',
    AVAILABLE_BALANCE: '可用余额',
    RULE: '所有银行卡的总限额之和不得超过5,000,000.00索姆。\n请调整其他限额设置',
    EMPTY_CARD: '无可用卡片',
    EMPTY: '该时间段内无数据',
    YOUR_CARD_IS_BLOCKED: '您的银行卡已停用',
    YOUR_CARD_IS_BLOCKED_DESCRIPTION: '如需解锁，请前往Optima Bank网点办理',
    COMMISSION: '手续费',
    FILTER_HINT: '如需生成2025年2月13日之前的对账单，请前往分支机构办理。',
    INFORMATION: {
      CARD_ACCOUNT: '卡账户',
      ALL: '全部',
      REPLENISHMENT: '充值',
      FILTER: '筛选',
      WRITE_OFF: '扣款',
      SET: '应用',
      THREE: '最近3天',
      WEEK: '最近一周',
      MONTH: '最近30天',
      TOTAL_RECEIPTS: '收入总计',
      TOTAL_WRITE_OFF: '支出总计',
      PERIOD_START_BALANCE: '期初余额',
      PERIOD_END_BALANCE: '期末余额',
    },
    BLOCK_CARD: {
      LOSS: '银行卡遗失',
      THEFT: '银行卡被盗',
      COMPROMISING: '银行卡信息泄露',
      TEMPORARY: '临时锁定',
      TEXT: '卡片被锁定后，将无法用于交易。您可以在银行网点解锁卡片。如卡片遗失或怀疑数据泄露，建议您重新办理卡片。',
      BLOCK: '银行卡锁定',
    },
    RENAME: {
      RENAME_CARD: '银行卡重命名',
      NAME_CARD: '银行卡名称',
      SET_NAME: '重命名',
      DESIRED_NAME: '请输入期望的银行卡名称',
      SUCCESS: '银行卡名称修改成功',
    },

    SHARED: {
      SET: '设置',
      RESET: '重置',
      LIMIT_IN_DAY: '每日限额（索姆）',
      DATE_TO: '结束日期',
      DATE_FROM: '开始日期',
      AVAILABLE_AMOUNT: '可用金额',
      AVAILABLE_AMOUNT_TRANSACTION: '可交易次数',
      AVAILABLE_AMOUNT_TRANSACTION_IN_DAY: '交易次数（每日）',
      AVAILABLE_OUT_OF: '可用{available}次，共{outOf}次',
      MAIN_BALANCE: '主要余额',
      CARD_ACCOUNT: '卡账户',
      CARD: '银行卡',
      NOT_HAVE_CARD_ACCOUNT: '您没有银行卡账户',
    },

    CASH_LIMIT: 'ATM和POS终端取现',
    RETAIL_CARD_PRESENT: 'POS终端非现金购物',
    CARD_NOT_PRESENT: '网购/在线支付',
    ONLINE_PAYMENTS: '在线支付',
    FUNCTIONALITY_NOT_APPLY_RECURRING_PAYMENT: '此功能不适用于定期自动支付',
    OPERATION_ALLOWED: '允许的操作',

    DIALOG: {
      LIMIT: {
        SETTING: '正在设置限额',
        SUCCESS: '限额设置成功',
        ERROR: '错误，请稍后重试',
      },
      BLOCK: {
        SETTING: '正在设置锁定…',
        SUCCESS: '锁定设置成功',
        ERROR: '错误，请稍后重试',
      },
      UNLOCK: {
        SETTING: '正在解锁银行卡...',
        SUCCESS: '银行卡解锁成功',
        ERROR: '请稍后重试',
      },
    },

    SETTINGS_USER: {
      VIEW_CARD: '查看银行卡',
      BLOCK: '锁定/解锁',
      LIMITS: '设置限额',
      DETAILS: '查看限额',
      SUCCESS: '卡片设置已更改',
      VIEW_ACCOUNT: '查看卡账户',
      CARD_ACCOUNTS: '卡账户',
      NOTIFICATION_QR: '二维码转账推送通知',
      GENERATE_QR: '生成二维码',
    },
  },
  POS: {
    STATEMENT: 'POS机对账单',
    TITLE: 'POS终端',
    BANNER: {
      TITLE: '订购终端',
      LABEL: 'Optima卡和Elkart系统卡手续费为{value}%',
    },
    DIALOG: {
      CONFIRM_CLOSE: {
        TITLE: '确认退出？',
        LABEL: '申请草稿将不被保存',
      },
    },
    QUESTIONS: {
      TERMINALS_COUNTS: '需要订购多少台移动收款终端',
      ACCOUNT: '销售款项入账到哪个账户？',
      ADDRESS: '移动收款终端安装在哪里？',
      USER: '谁为该销售点负责人？',
      WORKING_DAYS: '营业时间？',
    },
    ONBOARDING: {
      TERMINAL: {
        HEADER: '支持银行卡和二维码支付',
        SUB_HEADER: '移动支付终端支持Visa、Mastercard、UnionPay和Elkart卡支付',
        COMMISSION: '手续费{value}% ',
        COMMISSION_HINT: 'Optima卡和Elkart系统卡',
        CARD_HINT: '其他银行和系统的卡',
        DELIVERY: '快速配送',
        DELIVERY_HINT: '三个工作日内',
        FLEX_COMMISSION: '灵活支付手续费',
        ABOUT_TARIFF: '了解更多资费详情',
      },
      PHOTO: {
        HEADER: '为完成申请准备两张销售点的照片',
        SUB_HEADER: '可在办理时拍照，也可提前准备——您方便即可',
        EXPECTATION: '照片要求',
        OUTSIDE: '外部',
        OUTSIDE_HINT: '可见招牌和入口',
        INSIDE: '内部',
        INSIDE_HINT: '可见柜台和室内环境',
      },
      AGREEMENT: {
        LABEL: '点击‘提交申请’即表示同意',
        LINK: '合同条款',
      },
    },
    ORDER: {
      TITLE: '终端申请 | 终端申请',
      SUB_TITLE: '订购终端',
      APPLICATION: '申请 | 申请',
      SUBMIT_APPLICATION: '提交申请',
      ADD_KKM: '为订单添加收银机',
      ENROLLMENT_ACCOUNT: '收款账户',
      STORE_NAME: '销售点名称',
      OFFER_TYPES: '您的商品和服务',
      HAS_SECURITY: '销售点是否有监控或安保',
      FRONT_PHOTO: '上传销售点外部照片',
      FRONT_PHOTO_DOWNLOADED: '网点外部照片已上传',
      BACK_PHOTO: '上传销售点内部照片',
      BACK_PHOTO_DOWNLOADED: '网点内部照片已上传',
      WORKING_DAYS_HINT: '选择一周中的一天或几天，以确定营业时间',
      OPENING: '开始营业',
      CLOSING: '结束营业',
      ADD_SCHEDULE: '添加营业时间',
      DELETE_SCHEDULE: '删除营业时间',
      SUBMIT: '提交申请',
      SENT_TO_REVIEW: '已提交审核',
      SENT_HINT: '可在申请板块追踪状态',
      TO_APPLICATIONS: '前往申请',
    },
    ABOUT_KKM: {
      TITLE: '什么是收银机',
      SUB_TITLE: '收银机或KKM',
      LI_1: '帮助记录销售情况',
      LI_2: '打印税务票据',
      LI_3: '自动向税务局传输数据',
      FOOTER: '将KKM加入订单，以减少您的文书工作负担',
    },
    RULE: {
      INVALID_PHOTO_EXTENSION: '上传文件类型禁止。允许的文件类型：.heic .png .jpeg\n请删除文件并上传允许类型的文件',
      FILE_LARGE_ERROR: '您上传的文件大小超过最大允许大小5MB。\n请删除文件并上传较小尺寸的文件',
    },
    STATUS: {
      COMPLETED: '已批准',
      IN_PROCESS: '审核中',
      REJECTED: '已拒绝',
      REJECT_REASON: '拒绝原因',
    },
    TASKS: {
      TITLE: '申请',
      STORE_NAME: '销售点',
      TERMINALS_COUNT: '终端数量',
      CREATE_DATE: '申请日期',
      ERROR: '无法获取申请',
    },
    DETAILS: {
      TERMINALS: '终端',
      TO_ORDER: '加入订单',
      KKM: '收银机',
      PLACE: '销售点',
      NAME: '名称',
      OFFER_TYPES: '商品和服务',
      RESPONSIBLE_PERSON: '负责人',
      WORK_SCHEDULE: '营业时间',
      ERROR: '无法获取申请详情',
    },
  },
  SALARY: {
    ONBOARDING: {
      TITLE: '将发薪交给银行：节省手续费，告别繁琐流程。',
      CONNECT: '立即接入',
      FEE_FREE: { TITLE: '0% 手续费', DESCRIPTION: '向员工转账完全免费。' },
      INSTANT_CREDIT: { TITLE: '即时到账', DESCRIPTION: '工资单签署后资金立即划入员工卡。' },
      SUPPORT: { TITLE: '可靠支持', DESCRIPTION: '为您提供全程支持。' },
      ANYTIME: { TITLE: '24/7 随时发放', DESCRIPTION: '全天候随时发送工资单。' },
      STEP_TWO: {
        TITLE: '请前往开立结算账户的银行网点',
        SUBTITLE: '接入工资项目仅需很短时间。接入后，您就可以通过 Optima Business 方便地为员工发放工资。',
        ADDRESS_LABEL: '银行网点地址',
        IMPORTANT: '重要提示！请携带护照及公司所需文件。',
      },
    },
    BANNER: {
      TITLE: '通过对公账户发放工资',
      INFO: '无需预转账至过渡账户和Excel表格，直接在网站上生成工资单',
    },
    DELETE_ALL: '删除全部',
    LOADING_CHANGE_SETTINGS: '正在加载',
    SUM: '金额',
    TOTAL: '总计',
    WITHDRAWAL_ACCOUNT: '扣款账户',
    CODE_COMPANY: '公司代码',
    NAME_COMPANY: '公司名称',
    ACCOUNT_NUMBER: '对公账户账号',
    AMOUNT_CREDIT: '划入卡账户总额',
    SELECT_TEMPLATE: '从模版中选择',
    CREATE_SALARY: '创建工资单',
    UPLOAD_TEMPLATE: '上传Excel报表',
    EMPLOYEES: '员工',
    IN_REVIEW: '待审核',
    TO_STATEMENTS: '生成工资单',
    CREDITED_AMOUNT: '发放总额',
    SEND_STATEMENT: '发放审核',
    ADD_STATEMENT: '添加工资单',
    DOWNLOAD_TEMPLATE: '下载Excel模版',
    SELECTED_EMPLOYEE: '已选员工',
    ID_COMPANY: '公司ID',
    TRANSFER_ACCOUNT: '入账账户',
    SELECT_ALL: '选择全部',
    ADD_EMPLOYEE: '添加员工',
    ADD_TEMPLATE: '添加至模版',
    AMOUNT_COMMISSION: '手续费金额',
    TOTAL_SUM: '总金额',
    COMPANY_NAME: '公司名称',
    TRANSIT: '过渡工资账户',
    RKO: '工资结算账户',
    STATEMENT_NAME: '工资单名称',
    NOT_CONNECTED_SALARY: '工资项目未开通',
    IMPORT: '上传工资单',
    CAUSE: '原因',
    TOTAL_AMOUNT: '总金额',
    BACK_TO_SALARY: '返回工资项目',
    DELETE_STATEMENT: '工资单已删除',
    DELETING_STATEMENT: '正在删除工资单',
    INFO: {
      TITTLE: '从上传工资单到向员工发放资金的完整流程包含以下步骤：',
      SUB_TITTLE:
        '1) 上传正确填写的工资单。务必使用已核准的模板！\n2) 随后工资单进入第一阶段，系统会自动检查填写正确性、员工卡状态及扣款账户余额。\n3) 在第一阶段获得“已处理”状态后，工资单将以“准备签署”状态进入第二阶段，需在17:00前发送签署，并在17:25前完成签署。“已完成”状态表示资金已发放至员工账户。',
    },
    MORE_DETAILS: '了解更多',
    TITLE: '工资项目',
    ATTACHED_FILE: '文件附件',
    PAY_CONTROL_NOT_AVAILABLE: '无法发送工资单待签署。其中一位签署人未开通PayControl',
    TABS: {
      EMPLOYEE: '员工',
      STATEMENT: '工资单',
    },
    FAQ: {
      TITLE: '常见问题 — 工资项目',
      VIDEO: '观看视频指南',
      TOPICS: {
        CREATE: {
          TITLE: '创建工资单',
          WHEN: {
            TITLE: '使用场景',
            TEXT: '如需手动创建并向员工发送工资单，请使用此功能。',
          },
          STEPS: {
            TITLE: '操作步骤',
            ITEM: {
              1: '进入“工资项目”→“工资单”。',
              2: '选择“添加工资单”→“创建工资单”。',
              3: '选择扣款账户。',
              4: '添加员工并输入付款金额。',
              5: '填写完成后，工资单状态将变为“待签署”。',
              6: '打开工资单并选择“提交签署”。',
              7: '进入“待签署付款”。',
              8: '选择工资单并选择“签署”。',
            },
          },
          EXTRA: {
            TITLE: '更多功能',
            ITEM: {
              1: '工资单完成后，您可以下载带银行印章的PDF文件。',
              2: '如需定期付款，请选择“重复”——系统将自动填入上次工资单中的员工和金额。',
            },
          },
        },
        EXCEL: {
          TITLE: '通过Excel上传工资单',
          NOTICE: '重要！如果工资单状态变为“已拒绝”，请检查Excel模板填写是否正确，并重新上传。',
          WHEN: {
            TITLE: '使用场景',
            TEXT: '如需从Excel文件批量导入员工数据，请使用此功能。',
          },
          STEPS: {
            TITLE: '操作步骤',
            ITEM: {
              1: '进入“工资项目”→“工资单”。',
              2: '选择“下载Excel模板”。',
              3: '在模板中填写员工数据。',
              4: '将文件保存到您的设备。',
              5: '选择“上传工资单”。',
              6: '选择已填写的Excel文件。',
              7: '上传成功后，工资单状态将变为“待签署”。',
              8: '打开工资单并选择“提交签署”。',
              9: '进入“待签署付款”。',
              10: '选择工资单并选择“签署”。',
            },
          },
          REQUIREMENTS: {
            TITLE: 'Excel模板要求',
            ITEM: {
              1: '请勿更改文件格式。',
              2: '请勿删除公式。',
              3: '请勿留空行。',
              4: '请保持模板结构不变。',
            },
          },
          EXTRA: {
            TITLE: '更多功能',
            ITEM: {
              1: '工资单完成后，您可以下载带银行印章的PDF文件。',
              2: '如需定期付款，请使用“重复”按钮。',
            },
          },
        },
        CONNECT_EMPLOYEE: {
          TITLE: '将员工加入工资项目',
          NOTICE: '重要！开通前，请确认该员工已添加至系统并拥有所需的访问权限。',
          WHEN: {
            TITLE: '使用场景',
            TEXT: '如需为员工开通工资项目权限，请使用此功能。',
          },
          STEPS: {
            TITLE: '操作步骤',
            ITEM: {
              1: '进入“设置”→“用户”。',
              2: '选择员工。',
              3: '开启“工资项目”开关。',
            },
          },
          RESULT: {
            TITLE: '操作结果',
            ITEM: {
              1: '开通后，员工将获得工资项目项下的结算账户。',
              2: '关闭该开关后，工资项目权限将被关闭。',
            },
          },
        },
        ERRORS: {
          TITLE: '工资单错误',
          NOTICE: '建议。重新提交前，请核实员工信息、付款金额及所选扣款账户是否正确。',
          WHEN: {
            TITLE: '使用场景',
            TEXT: '如工资单被拒绝或处理失败，请查阅此内容。',
          },
          REASONS: {
            TITLE: '可能出现的错误',
            ITEM: {
              1: {
                TERM: '被第一审批人拒绝',
                TEXT: '—文件在签署阶段被拒绝。',
              },
              2: {
                TERM: '签署时限已过',
                TEXT: '—文件等待签署的时间过长。',
              },
              3: {
                TERM: '未通过审核',
                TEXT: '—工资单中存在错误或数据不正确。',
              },
              4: {
                TERM: '被银行拒绝',
                TEXT: '—文件未能通过银行端处理。',
              },
            },
          },
          RETRY: {
            TITLE: '重新提交工资单',
            ITEM: {
              1: '打开出现错误的工资单。',
              2: '选择“重复”。',
              3: '系统将自动恢复：扣款账户；员工名单；付款金额。',
              4: '如有需要，请进行修改。',
              5: '选择“提交审核”。',
            },
          },
        },
      },
    },
    EMPLOYEE: {
      EMPTY: '列表为空',
      FILTER_EMPTY: '未找到符合指定参数的员工',
      SEARCH_PLACEHOLDER: '搜索员工',
      PAY_CONTROL_NOT_AVAILABLE: '无法对员工执行操作。其中一位签署人没有 PayControl。',
      ADD: {
        INN: '员工税号',
        INN_ERROR: '请输入14位纳税人识别号（TIN）',
        LIMIT: '一份文件最多可添加{count}名员工',
        TO_ADD: '待添加员工：',
        ACCOUNT_REQUIRED: '请选择卡片',
        SEARCH_RESULTS: '搜索结果',
        ALREADY_ADDED: '该员工已添加',
        ALREADY_IN_PROJECT: '该员工已是本工资项目的成员。',
        CARD_NUMBER: '卡号',
        ACCOUNT: '账户',
        NO_CARDS: '该员工没有可用于发放工资的卡',
        LOADING_CARDS: '正在加载卡片...',
        NOT_FOUND: '未找到与该纳税人识别号对应的员工。',
        SAVE_CHANGES: '保存更改',
        SEND_FOR_SIGNING: '发送签署',
        SUCCESS: '经第一审批人确认后，该员工将加入工资项目。',
        SUCCESS_BULK: '经第一审批人确认后，这些员工将加入工资项目。',
        GOT_IT: '知道了',
        SELECT_ACCOUNTS: '请为所有员工选择卡',
        EMPTY_LIST: '请至少添加一名员工',
      },
      EDIT: {
        SENT_BUTTON: '确定',
        TITLE: '编辑员工',
        NO_CARDS: '该员工没有可用的银行卡',
        SAME_ACCOUNT: '新账户与当前账户相同',
        SENT_MESSAGE: '经第一审批人确认后，入账账户将更新。',
      },
      RESTORE: {
        ACTION: '恢复',
        CONFIRM_TITLE: '是否将该员工恢复到工资项目？',
        CONFIRM_TITLE_BULK: '是否将所选员工恢复到工资项目？',
        SENT_MESSAGE: '经第一签署人确认后，该员工将重新加入工资项目。',
        SENT_MESSAGE_BULK: '经第一签署人确认后，{count} 名员工将重新加入工资项目。',
        RESET_SELECTION: '清除选择',
      },
      DELETE: {
        CONFIRM_TITLE: '是否将该员工移出工资项目？',
        CONFIRM_TITLE_BULK: '是否将所选员工移出工资项目？',
        SENT_MESSAGE: '经第一签署人确认后，该员工将从工资项目中删除。',
        SENT_MESSAGE_BULK: '经第一签署人确认后，{count} 名员工将从工资项目中删除。',
      },
      FILTER: {
        TITLE: '筛选和排序',
        BY_CREATED_DATE: '按添加日期',
        NEWEST_FIRST: '最新优先',
        OLDEST_FIRST: '最早优先',
        APPLY: '应用',
        RESET: '全部重置',
      },
      CHIPS: {
        ADDED: '已添加',
        FOR_SIGNING: '待签署',
        DELETED: '已删除',
        REJECTED: '已拒绝',
      },
      ERROR: {
        TITLE: '加载员工时发生错误',
      },
      STATUS_LABEL: {
        EMPLOYEE_IN_PROCESSING_BANK: '银行处理中',
        EMPLOYEE_ERROR_CREATED: '未能添加员工',
        EMPLOYEE_REJECTED: '被第一审批人拒绝',
        EMPLOYEE_CLOSED: '已移除',
        EMPLOYEE_CARD_NOT_LINKED_YET: '银行卡尚未绑定',
        EMPLOYEE_CARD_FAILED_ADD: '未能添加卡片',
        EMPLOYEE_CARD_BLOCKED: '卡片已锁定',
        EMPLOYEE_CARD_SUCCESS: '员工已添加',
        EMPLOYEE_AWAITING_CREATION: '待添加',
        EMPLOYEE_AWAITING_EDIT: '待编辑',
        EMPLOYEE_AWAITING_CLOSING: '待删除',
        UNKNOWN: '未知状态',
      },
    },
    STATEMENT: {
      DIALOG: {
        RETURN: '返回',
        SALARY_RELOADING: ' 正在重新启动工资单流程…',
        STATEMENT_IS_REJECTED: ' 工资单正在撤销流程中',
        STATEMENT_REJECTED: '工资单已拒绝',
        SENDING_STATEMENT: ' 正在发送工资单待签署…',
        STATEMENT_SENT: '工资单已发送',
        STATEMENT_SIGNED: '工资单已成功签署',
        STATEMENT_IS_SIGNED: '金额为{sum} {currency}的工资单正在签署中...',
      },
      COLUMN_TABLE: {
        NUMBER: '№',
        FILE_NAME: '名称',
        TOTAL_AMOUNT: '最终金额',
        NUMBER_CARD: '卡账户号码',
        DOWNLOAD_DATE: '创建日期',
      },
      EMPTY: '无已上传的工资单',
      ERROR: {
        TITLE: '加载工资单时出现错误',
      },
    },
    CONTRACT: {
      TITLE: '工资合同信息',
      ID: '工资项目ID',
      ACCOUNT: '过渡账户',
      STATUS_LABEL: {
        CONTRACT_ON_VERIFICATION: '合同验证中',
        CONTRACT_VERIFICATED: '合同已通过验证',
        CONTRACT_REJECTED: '合同被验证人驳回',
        CONTRACT_PENDING_CLOSURE: '合同等待关闭',
        CONTRACT_CLOSED: '合同已关闭',
        CONTRACT_PENDING_UNCLOSE: '合同等待开启',
      },
    },
    DOWNLOAD: {
      TEXT: '下载模版',
      ERROR: '上传文件时发生错误',
      ERROR_HELP: '请再次点击下载',
      DOWNLOADING_STATEMENT: '工资单下载中',
    },
    ERROR: {
      TITLE: '加载工资单时发生错误',
      MIN_AMOUNT: '请输入从1{currency}起的金额',
      MAX_AMOUNT: '请输入不超过1,000,000,000{currency}的金额',
      BALANCE_IS_LESS_AMOUNT_ERROR: '账户余额不足',
    },
    NOTIFICATION: {
      STATUS: {
        ERROR: {
          TEXT: '银行拒绝了工资单。金额{amount} {currency}',
        },
        SUCCESS: {
          TEXT: '银行拒绝了工资单。金额{amount} {currency}',
        },
      },
    },
  },
  LETTER: {
    DOWNLOAD: {
      ERROR: '上传文件时发生错误',
      ERROR_HELP: '请再次点击下载按钮',
    },
    TITLE: '信件',
    ATTACHED_FILE: '附件',
    CREATED: '创建于 ',

    REVOKE: '拒绝',
    SIGN: '签署',
    FOR_SIGN: '待签署',
    DELETE: '删除',

    NOTIFICATION: {
      TITLE: '银行新来信',
      TEXT: '银行对您的第№号来信已回复',
    },
    EMPTY: {
      OUTGOING: '您没有已发送信件',
      INCOMING: '您没有已收信件',
    },
    ERROR: {
      TITLE: '加载信件时出现错误',
    },
    NAV: {
      OUTGOING: '发出的',
      INCOMING: '收到的',
    },
    CREATE: {
      CREATE_LETTER: '创建信件',
      DATE: '创建日期',
      NAME_COMPANY: '公司名称',
      TOTP: '向银行发送信件确认时，请输入TOTP码',
      ENTER_TOTP: '请输入TOTP码',
      SELECT: {
        SUBJECT: '信件主题',
        SUBJECT_EMPTY: '点击选择信件主题',
        MONEY_TRANSFER: '资金转账相关文件 ',
        PAYMENT_CANCELLATION: '取消付款',
        PERSONAL_DOCUMENT: '个人文件',
        OTHER: '其他',
      },
      ENTER_SUBJECT: '请输入您的信件主题',
      ENTER_TEXT: '请输入信件正文',
      ATTACH_FILE: '添加附件',
      ALLOWED_TYPES: '(10 MB，允许的文件类型: .xls .xlsx .doc .docx .pdf .jpg .png .pptx .zip .txt)',
      FOR_SIGN: '待签署',
      RULES: {
        ENTER_SELECT: '请从此下拉列表中选择要创建的信件主题',
        ENTER_TEXT: '请在此栏中撰写要创建的信件正文',
        ENTER_OTHER_TEXT: '请在此栏中撰写要创建的信件主题',
        INVALID_EXTENSION:
          '附件文件类型不允许。允许的文件类型: .xls .xlsx .doc .docx .pdf .jpg .png .pptx .zip .txt\n请删除附件并上传允许类型的文件',
        FILE_LARGE: '您附加的文件大小超过最大允许的10兆字节。请删除附件并上传较小尺寸的文件',

        INVALID_TOTP: '您输入的TOTP码不正确。请重新输入正确的TOTP码',
        INVALID_CHARACTER_TITLE: '您在信件主题中使用了无效字符 ',
        INVALID_CHARACTER_MESSAGE: '您在信件正文中使用了无效字符 ',
      },
      DIALOG: {
        SENDING: '发送信件',
        REPEAT: '发送信件',
        NOT_SEND: '信件未能发送',
        COME_BACK: '返回',
        SENT_FOR_SIGN: '信件已发送待签署',
        COME_BACK_LETTER: '前往信件',
        SAVED_TO_DRAFT: '信件已保存为草稿',
        ERROR_AFTER_DRAFT: '未能将信件发送待签署。信件已保存为草稿',
        SUCCESS_DELETE: '信件已删除',
        FAILED_DELETE: '未能删除信件',
        FAILED_SAVED_TO_DRAFT: '未能将信件保存为草稿',
        FAILED_SEND_FOR_SIGN: '未能将信件发送待签署',
        SIGN_LETTER: '信件已签署',
        FAILED_SIGN_LETTER: '未能签署信件',
        SUCCESS_REVOKE: '信件已拒绝',
        FAILED_REVOKE: '未能拒绝信件',
      },
    },
    STATUS: {
      OUTGOING: {
        NOT_PROCESSED: '未处理',
        IN_PROCESSING: '处理中',
        PROCESSED: '已处理',

        ON_VERIFICATION: '待签署',
        FIRST_SIGN_IN_PAY_CONTROL: '待签署',
        TIMEOUT_CANCELED_SIGN_ONE: '因超时拒绝',
        CANCELED_SIGN_ONE: '已拒绝',
        DRAFT: '草稿',
      },
      INCOMING: {
        NOT_PROCESSED: '新信件',
        PROCESSED: '已读',
      },
    },
  },
  OUTLET: {
    LUNCH_BREAK: '午休',
    NEW_POINT: '新销售点',
    CASH_ADD: '添加收银机',
    POINT_ADD: '添加销售点',
    CASH: '收银机',
    SALE_POINTS: '销售点',
    SALE_POINT: '销售点',
    ALL_POINTS: '所有销售点',
    EMPLOYEES: '收银员',
    CREATE_QR: '创建二维码',
    SHOW_ALL: '查看全部',
    QR_CODE: '二维码',
    NAME: '名称',
    DELETE_ALL: '删除全部',
    SELECT_ALL: '选择全部',
    ADD_EMPLOYEE: '添加收银员',
    ADD_ADDRESS: '添加地址',
    ADD_PHONE: '添加号码',
    CHANGE_ACCOUNT_SETTINGS: '请在设置中修改账户访问权限',
    SORT_NEWEST: '新的在前',
    SORT_OLDEST: '旧的在前',
    SORT_ALPHABETICALLY: '按字母顺序',
    NEW_CASH: '新的收银机',
    GRANT_ACCESS: '授予访问权限',
    EMPTY_EMPLOYEES: '暂无收银员',
    EMPTY_SEARCH_EMPLOYEES: '无此姓名收银员',
    EMPTY_SEARCH_POINT: '无此名称销售点',
    POINT_ACCESS_DENIED: '无销售点访问权限',
    CASH_ACCESS_DENIED: '无收银机访问权限',
    EMPLOYEE_ACCESS_DENIED_CASH: '收银员无收银机访问权限',
    EMPTY_CASHES: '无此编号收银机',
    ONBOARDING: {
      HEADER: '添加销售点',
      SUB_HEADER: '您将能在应用中跟踪销售并添加收银员',
      QR: '为每台收银机创建二维码',
      HISTORY: '查看销售点及每台收银机的销售历史',
      ACCESS: '向收银员授予访问权限，以便他们查看历史记录',
      ADD_POINT: '添加销售点',
    },
    REVOKE_ACCESS: '撤销销售点',
    EDIT_WITH_KKM: '该销售点已关联KKM收银机。如需修改数据，需先删除KKM收银机',
    FORM: {
      QUESTIONS: {
        NAME: '销售点名称是什么？',
        ACCOUNT: '款项入账至哪里？',
        ADDRESS: '销售点位于何处？',
        PHONE: '如何联系销售点？',
        SOCIAL: '网点地址与社媒链接',
      },
      POINT_NAME: '销售点名称',
      CHECK_NAME: '收据显示名称',
      CHECK_HINT: '请输入拉丁字母的收据显示名称——它将显示在销售收据上',
      ACCOUNT_HINT: '若更改入账账户，请创建新的二维码',
      REGION: '州',
      CITY: '州，区或城市',
      DISTRICT: '城市区域或乡村',
      ADMINISTRATIVE_TERRITORY: '行政区域',
      IN_BUILDING: '楼内',
      NEARBY: '附近',
      COMPANIES_IN_BUILDING: '选择组织',
      STREET_OR_MKR: '街道或小区',
      HOUSE: '门牌号',
      POSTAL_CODE: '邮政编码',
      TRADE_CENTER_OR_MARKET_POINT: '商场或市场中的点位',
      WORKING_HOURS: '营业时间',
      WORKING_FROM: '从',
      WORKING_TO: '到',
      SELECTED_COMPANY: '已选公司',
      NEARBY_COMPANIES: '附近公司',
      MAP_PICKER_TITLE: '添加地址',
      ADDRESS_SEARCH_PLACEHOLDER: '请输入公司地址',
      CURRENT_LOCATION: '当前位置',
      GEOLOCATION_ERROR: '无法获取当前位置',
      LOAD_MORE_COMPANIES: '显示更多',
      COMPANY_BRANCHES_LOAD_ERROR: '无法加载公司。请重试',
      ORGANIZATION_BRANCHES: '组织分行',
      SELECT_BRANCH: '请选择分店',
      SUGGEST_ORG_BRANCHES: '{count} 家分店，{city}',
      ADDRESS_NOT_FOUND: '未找到地址',
      TWO_GIS_NOT_FOUND: '未找到任何内容，请尝试优化搜索条件',
      ADD_PHONE: '添加号码',
      PHONES: '电话号码',
      TWO_GIS: '2GIS 地址链接',
      TWO_GIS_SHORT: '2GIS',
      COPY_LINK: '链接已复制',
      ENTER_TWO_GIS: '请粘贴 2GIS 链接',
      SOCIAL_NETWORK: '网点社交链接',
      SOCIAL_NETWORK_SHORT: '社交网络',
      PLACED_IN_MALL: '销售点位于购物中心或市场内',
      ADD_SOCIAL_NETWORK: '添加',
      ENTER_SOCIAL_NETWORK: '粘贴社交链接',
      MALL: '购物中心',
      MALL_NAME: '购物中心名称',
      FLOOR: '楼层',
      BOUTIQUE: '店铺编号',
      MARKET: '市场',
      MARKET_NAME: '市场名称',
      MARKET_ROW: '排号',
      CONTAINER: '集装箱',
    },
    RULE: {
      SAME_PHONE: '该号码已存在。请输入其他电话号码',
      ACCOUNT_FORBIDDEN: '无账户访问权限',
    },
    DIALOG: {
      POINT_IS_READY: '销售点 «{name}» 已准备就绪',
      ADD_MORE_POINT: '添加更多销售点',
      TO_POINT_LIST: '返回销售点列表',
      CHANGE_ACCOUNT: {
        TITLE: '入账账户将变更适用于所有销售点',
        DESCRIPTION: '合同第{number}号下的所有销售点共享同一账户——若您更改该账户，它将在所有这些销售点中更新：',
      },
      QT_HINT_INVITED: '请分享链接及二维码。柜员进入 Optima Business 后，您需在“柜员管理”中授予其访问权限。',
      QR_HINT: '收银机的二维码将继续有效，但款项将转入其他结算账户。请重新创建二维码，以使款项转入新的入账账户',
      CASH_IS_READY: '收银机 {code} 已准备就绪',
      CASH_IS_READY_HINT: '它在 «{name}»中可用',
      ADD_MORE_CASH: '添加更多收银机',
      TO_CASH_LIST: '返回收银机列表',
      REVOKE_ACCESS_TITLE: '撤销对所有收银机的访问权限？',
      REVOKE_ACCESS_MESSAGE: '{name} 将无法跟踪销售情况',
      DO_YOU_WANT_REVOKE: '确认撤销对所有收银机的访问权限？',
      FINISH_CHANGES_TO_REVOKE: '完成修改后点击‘撤销访问权限',
      DELETE_CASHIER: '删除 «{name}»收银员？',
      DELETE_CASHIER_MESSAGE: '收银员 {name} 将无法再登录Optima Business',
      CASHIER_DELETED: '收银员已删除',
      CHANGES_WILL_NOT_BE_SAVED: '如果您已进行修改，更改将不会保存',
      ACCESS_REVOKED: '访问权限已撤销',
      CASHIER_STATUS_INFO: '收银员需输入用户名和临时密码以登录应用',
      CASHIER_STATUS_SUCCESS: '收银员完成注册即可使用应用',
      CONFIRM_CLOSE: {
        ADD_OUTLET: '如果您已输入销售点数据，将不会保存',
        ADD_CASH: '如果您已输入收银机数据，将不会保存',
        EDIT_CASH: '收银机的更改将不会保存',
        ADD_CASHIER: '您已输入收银员数据将不会保存',
      },
      ACTION: {
        REVOKE: '撤销',
        COPY_LINK: '复制链接',
      },
    },
    MORE_OUTLETS: '更多销售点 | 还有 {count} 个销售点 | 还有 {count} 个销售点 | 还有 {count} 个销售点',
    MORE_EMPLOYEES: '更多员工 | {count} 名员工 | {count} 名员工 | {count} 名员工',
    MORE_CASHES: '更多收银机 | {count} 台收银机 | {count} 台收银机 | {count} 台收银机”',
    MORE_CASHES_PREFIX: '更多收银机 | 还有 {count} 台收银机 | 还有 {count} 台收银机 | 还有 {count} 台收银机',
    DETAILS: {
      SALES: '销售',
      CASH_REGISTERS: '收银机',
      ABOUT_POINT: '关于销售点',
      LIST_QR: '二维码列表',
    },
    EMPLOYEE: {
      TITLE: '新收银员',
      ACCESS_OTHER_CASH: '授予其他收银机的访问权限',
      INFO_SUBTITLE: '填写收银员信息',
      ACCESS_SUBTITLE: '授予哪些收银机的访问权限',
      ACCESS_SELECTED_CASH: '授予哪些收银员访问权限？',
      NOT_FOUND: '未找到具有该税务识别码的Optima客户',
      ALREADY_ACTIVE: '已存在具有该税务识别码的收银员',
      DID_NOT_SELECTED: '请至少选择一台收银机',
      SELECT_ALL: '选择所有收银机',
      CASH_NUMBER: '收银机编号',
      ADD_MORE: '添加更多收银员',
      TO_LIST: '返回收银员列表',
      MUST_ENTER_LOGIN_PASSWORD: '{name} 需输入用户名和临时密码以登录应用',
      EMPLOYEE_WITH_ACCESS: '具有访问权限的收银员',
      FIRST_OR_SECOND_NAME: '姓名',
      ABOUT_EMPLOYEE: '关于收银员',
      CASHES: '收银机',
      QR_ADD: '生成二维码',
      INN_ADD: '按 纳税人识别码 添加',
    },
    STATUS: {
      INIT: '已发送登录信息',
      CONFIRM: '已添加',
      ON_VERIFICATION: '审核中',
      DECLINED: '已拒绝',
      APPROVED: '已通过',
    },
    BANNER: {
      TITLE: '已将全部销售点整合至一处',
      DESCRIPTION: '现在可查看终端及二维码支付的完整信息',
    },
    HISTORY_INVITED: '申请记录',
    APPROVED_CASHIER: '{name} 已加入您的公司',
    DECLINED_CASHIER: '申请“{name}”已取消',
    CANCEL_CASHIER: '是否取消柜员“{name}”的申请？',
    NOT_CANCEL: '否，不取消',
    YES_CANCEL: '是，取消',
    ACCEPTED: '{name} 已通过',
    REJECTED: '{name} 已拒绝',
    APPLICATION_SENT_TO_MANAGER: '申请已发送给经理。',
    INVITED: '已邀请',
    PAYMENT_FOR: '支付用途：{name}',
    LAST_PAYMENT: '最近一笔付款',
    NO_FIRST_PAYMENT: '用户尚未完成首笔付款',
    QR_SORT_BY_DATE: '按二维码创建日期',
    QR_SORT_NEW: '新的',
    QR_SORT_OLD: '旧的',
    ENTER_PURPOSE: '请输入用途',
    LAST_TRANSACTION_DATE_TIME: '按最近一笔付款',
    NO_PERSONAL_QR: '您还没有生成个人二维码',
    AMOUNT_EDITING: '金额可编辑',
    AMOUNT_EDITING_DENIED: '不允许',
    AMOUNT_EDITING_ALLOWED: '允许',
    PERSONAL_QR_UPDATED: '编辑后，个人二维码的数据和金额会更新。请保存更新后的二维码并重新打印或下载。',
  },
  INSTALLMENT: {
    TITLE: '分期销售',

    TABS: {
      HISTORY: '历史',
      OUTLET: '销售点',
      ABOUT: '关于产品',
    },
    FILTER: {
      THREE: '近三天',
      WEEK: '近7天',
      MONTH: '近30天',
    },
    STATUS: {
      ALL: '全部',
      UNDER_REVIEW: '处理中',
      AWAITING_DELIVERY_OF_GOODS: '等待确认',
      CREDITING_FUNDS: '正向您账户入账',
      ISSUED: '已完成',
      REFUSED: '已拒绝',
      ACTIVE: '活跃',
      NON_ACTIVE: '非活跃',
      IN_PROCESS: '@:INSTALLMENT.STATUS.UNDER_REVIEW',
      ACCEPTED: '@:INSTALLMENT.STATUS.AWAITING_DELIVERY_OF_GOODS',
      PROCESSED: '@:INSTALLMENT.STATUS.ISSUED',
      REJECTED: '@:INSTALLMENT.STATUS.REFUSED',
      ERROR: '出错',
    },
    FILL_FIELD: '请输入取消原因',
    INCOMING_FOR: '{day}天收入',
    CONNECT: '连接 {product}',
    EMPTY: '未找到任何内容',
    PERIOD: '有效期',
    PERIOD_INFO: '分期付款受理服务将自动续期。如需关闭，请联系银行',
    TERM_COMMISSION: '期限与手续费',
    CONTACT_INFO: '联系信息',
    CONTACT_PERSON: '联系人',
    MY_CATEGORY: '我的类型',
    GO_TO_SALES: '前往销售',
    EMAIL: '电子邮件',
    TRY_AGAIN: '重试',
    TO_SALE_LIST: '返回销售列表',
    CONFIRM_SALE: '确认销售',
    SALE_REJECT: '销售被拒',
    SALE_CONFIRMED: '销售确认',
    SALE: '销售',
    DETAILS: '详情',
    CONTRACT_NUMBER: '详情',
    REPAYMENT_PERIOD: '还款期限',
    CUSTOMER: '买家',
    REJECT_TITLE: '为何拒绝？',
    REJECT_SALE: '拒绝销售',
    PLACEHOLDER_REJECT: '此商品不提供分期付款',
    REJECT_REASON: '拒绝原因',
    MONTH: '月',
    PROFIT_ALL_TIME: '累计收入',
    ADDRESS: '银行办公地址',
    FROM:
      '<span class="entity-installment-product-card__label">截至</span>\n' +
      '          <span class="entity-installment-product-card__value">{date}</span>',
    TO:
      '分期付款.至，<span class="entity-installment-product-card__label">截至</span>\n' +
      '          <span class="entity-installment-product-card__value">{date}</span>',

    ONBOARDING: {
      TO_SALE: '返回销售',
      PAY_DA: {
        TITLE_PRODUCT: 'ПАЙДА!提升销售额',
        TITLE_BANK: '请联系您开设结算账户的银行网点',
        DESCRIPTION_CONNECT: '请携带护照。我们将为您开通ПАЙДА!支付受理服务——这不会占用太长时间',
        DESCRIPTION_MONEY: '您可立即获得全部款项，而买家则分期向银行支付',
        DESCRIPTION_SALE: '助您提升销售额和平均客单价',
        DESCRIPTION_QR: '通过销售点二维码支付',
        BUTTON_GET_CASH: '我想增加销售',
        SEND_APPLICATION_TO_CONNECT: '提交开通申请',
        CONTACT_NAME: '姓名',
        SEND_APPLICATION: '提交申请',
        APPLICATION_SENT: '申请已提交',
        APPLICATION_SENT_HINT: '我们将尽快致电与您沟通细节',
        CREATE_OUTLET: '立即创建销售点',
        CREATE_OUTLET_LATER: '稍后创建',
        CREATE_DESCRIPTION: '要通过ПАЙДА!进行销售，您需要一个销售点——您可以立即创建',
      },
      TEZ_CREDIT: {
        TITLE_PRODUCT: '开通TEZ分期销售',
        TITLE_BANK: '请联系您开设结算账户的银行网点',
        DESCRIPTION_CONNECT: '请携带护照。我们将为您开通TEZ分期支付受理服务——这不会占用太长时间',
        DESCRIPTION_MONEY: '您可立即获得全部款项，而买家则分期向银行支付',
        DESCRIPTION_SALE: '助您提升销售额和平均客单价',
        DESCRIPTION_QR: '买家将通过您销售点的二维码办理分期，您确认发货后即可',
        BUTTON_GET_CASH: '如何开始销售',
      },
    },
  },
  NPT: {
    BANNER: {
      TITLE: '请先向税务局清偿债务，方可进行转账！',
      DESCRIPTION: '请联系您开立账户的银行网点',
    },
    DIALOG: {
      TITLE: '税务债务',
      DEBT: '债务 {number}',
      PAYMENT_REQUEST: '税务交款通知书',
      NOTICE: '通知单',
    },
  },
  INVOICE: {
    LIST_TITLE: '付款账单',
    TITLE: '付款账单',
    DIALOG: {
      CONFIRM_CLOSE: {
        LABEL: '付款账单草稿将不会保存',
      },
    },
    ISSUE: '开具发票',
    INCOMING: '收件箱',
    OUTGOING: '发件箱',
    PRODUCT: '商品与服务',
    ALLOW_PARTIAL_PAYMENT: '允许部分付款',
    MOBILE_TABS: {
      INVOICES: '账单',
      CATALOG: '目录',
    },
    OPEN_INVOICE: '打开账单',
    AVAILABLE_AROUND_THE_CLOCK: '24/7 全天可用',
    PAYMENT_AMOUNT: '支付金额',
    CREATED_AT: '创建',
    EXPIRES_AT: '账单有效期',
    IN_PROGRESS: '处理中',
    PAY: '支付',
    REJECT: '拒绝',
    ISSUED_INVOICE: '已开具账单',
    INVOICE_PAYMENT: '账单支付',
    INTRABANK_TRANSFER_BY_INVOICE: '根据付款账单的行内转账',
    PRODUCTS_MORE: '+ {count} 件商品',
    EMPTY_CATALOG: '目录中暂无商品或服务\n创建第一个项目并在开具账单时使用',
    EMPTY_OUTGOING: '您目前还没有已发送的账单。\n请创建您的第一张账单，以便为商品或服务请求付款。',
    EMPTY_OUTGOING_ACTION: '创建账单',
    EMPTY_INCOMING: '您目前还没有已接收的账单。\n其他公司向您开具的账单将显示在这里。',
    COUNTERPARTY: {
      SUPPLIER: '供应商',
      BUYER: '购买方',
    },
    TYPE_SHORT: {
      INDIVIDUAL: '个人',
      LEGAL: '法人',
    },
    TYPE_FULL: {
      INDIVIDUAL: '个人账单',
      LEGAL: '付款账单',
    },
    TYPE_MOBILE: {
      INDIVIDUAL: '个人账单',
      LEGAL: '付款账单',
    },
    TYPE_FILTER: {
      TITLE: '账单类型',
      LEGAL: '法人 / 个体经营者',
      INDIVIDUAL: '个人',
    },
    SERVICE_DIALOG: {
      TRIGGER: '服务条款与功能',
      TITLE: '服务条款与功能',
      DESCRIPTION: '账单服务可帮助您快速接收商品和服务的付款——支持 Optima 银行内及其他银行',
      INDIVIDUAL_DESCRIPTION: '面向个人的付款账单可帮助在 Optima 银行内快速接收商品和服务的付款',
      TARIFFS_TITLE: '费率',
      FOR_SOLE_PROPRIETORS: '对个体经营者',
      FOR_LEGAL_ENTITIES: '对企业',
      INTERNAL_BANK_LABEL: '在 Optima 银行内',
      OTHER_BANKS_LABEL: '来自其他银行',
      SOLE_INTERNAL_VALUE: '0.8%',
      SOLE_OTHER_VALUE: '1%',
      LEGAL_INTERNAL_VALUE: '1%',
      LEGAL_OTHER_VALUE: '1%',
      TARIFFS_NOTE: '部分客户可能适用个性化费率',
      FEATURES_TITLE: '功能',
      FEATURE_1: '在本行及其他银行开具账单',
      FEATURE_2: '资金即时到账',
      FEATURE_3: '自动更新支付状态',
      FEATURE_4: '服务全天候运行',
      FEATURE_5: '与 1C 集成',
      ACTION: '返回',
    },
    STATUS_INFO_DIALOG: {
      REJECTED_TITLE: '已拒绝',
      REJECTED_DESCRIPTION: '付款人拒绝支付账单。',
      CANCELLED_TITLE: '已取消',
      CANCELLED_DESCRIPTION: '账单在支付前已被开具方取消。',
      EXPIRED_TITLE: '已过期',
      EXPIRED_DESCRIPTION: '付款期限已过，账单已失效。',
      BACK: '返回',
    },
    COUNT_WIDGET: {
      TITLE: '您有 {count} 份待收付款账单',
      ACTION: '查看账单',
    },
    PRODUCTS_TABLE: {
      SEARCH_PLACEHOLDER: '搜索',
      ADD_BUTTON: '添加商品或服务',
      ADD_TITLE: '添加商品或服务',
      CODE: '编码',
      NAME: '名称',
      UNIT: '单位',
      QUANTITY: '数量',
      PRICE: '含税价格',
      TAXES: '税费',
      ACTIONS: '操作',
      DELETE_TITLE: '要删除商品吗？',
      DELETE_MESSAGE: '商品“{name}”的数据将不会保存',
      SAVED_TITLE: '修改已保存',
      PRODUCT_SAVED_TITLE: '商品已保存到目录',
      EDIT_TITLE: '编辑',
      NAME_LABEL: '名称',
      PRICE_LABEL: '含税价格',
      UNIT_LABEL: '计量单位',
      VAT_LABEL: '增值税率,%',
      SALES_TAX_LABEL: '销售税率,%',
      VAT_RATE: '增值税率',
      SALES_TAX_RATE: '销售税率',
      AMOUNT: '金额',
      EMPTY: '暂无商品/服务',
      CANCEL_TITLE: '不添加商品？',
      CANCEL_MESSAGE: '如果您已输入，数据将不会保存',
    },
    CREATE_PARAMS_TITLE: '账单参数',
    CREATE_RECIPIENT_TITLE: '账单接收方',
    PRODUCTS_TABLE_LIMIT_HINT: '在账单中最多可添加{count}个商品和/或服务，总金额不超过{sum}索姆',
    CASH_NUMBER_LABEL: '收银机编号',
    ACCOUNT_NUMBER_LABEL: '付款账单编号',
    ACCOUNT_NUMBER_AUTO_HINT: '如果未指定账号，将自动分配',
    VALIDITY_PERIOD_LABEL: '有效期',
    VALIDITY_EXPIRES_AT_HINT: '账单有效期：{date}',
    ACCOUNT_NUMBER: '账单编号',
    VALIDITY_DAYS: '账单有效天数',
    VALIDITY_DAYS_HINT: '若留空或为0，账单将有效至23:59',
    VALIDITY_DAYS_RANGE: '请输入 0 到 30',
    SALE_POINT_ACCOUNT: '资金将记入账户 - {account}',
    RECIPIENT_NAME_INN: '收款方名称/纳税人识别号',
    RECIPIENT_SEARCHING: '正在搜索收款方…',
    PURPOSE_COMMENT: '用途/备注',
    PURPOSE_PAYMENT_HINT: '请注明付款用途：用于什么或为谁支付',
    CONTINUE: '继续',
    STEPS: {
      REQUISITES: '付款信息',
      PRODUCTS: '商品和/或服务',
    },
    CREATE_INDIVIDUAL: '个人账单',
    CREATE_LEGAL: '付款账单',
    CONFIRM_ISSUE_TITLE: '付款账单已生成。',
    CONFIRM_ISSUE_MESSAGE: '选择发送方式',
    CONFIRM_ISSUE_ACTION: '通过 Optima Business 发送',
    SEND_MYSELF_ACTION: '自行发送',
    DOWNLOAD_TITLE: '下载',
    DOWNLOAD: '下载',
    BACK_TO_EDIT: '返回编辑',
    HINT: '仅可向Optima24用户发送付款账单',
    SUCCESS_SEND: '账单发送成功',
    SUCCESS_HINT: '您可在“付款账单”的“发件箱”标签页中跟踪账单状态',
    SUCCESS_HINT_CASH: '请在{salePoint}中关注交易状态',
    PDF_DOWNLOADED_TITLE: 'PDF账单已上传',
    PDF_DOWNLOADED_HINT: '请通过任何方便的方式将账单发送给付款人。您可以在“已发送”选项卡中跟踪付款状态。',
    PDF_DOWNLOADED_ACTION: '返回账单列表',
    DRAFT_SAVED_TITLE: '账单已保存为草稿',
    DRAFT_SAVED_HINT: '您可以在“付款账单”的“草稿”标签页找到它',
    TO_INVOICES: '返回账单列表',
    TO_SIGN: '待签署',
    SEND_INVOICE: '开具发票',
    REVOKED: '账单已撤销',
    REJECT_QUESTION: '是否拒绝此付款账单？',
    RECALL_QUESTION: '是否撤回此付款账单？',
    REJECT_SUCCESS: '账单已拒绝',
    EMPTY_SALE_POINT: '如需开具账单收款，请先添加销售点',
    ASK_SALE_POINT: '如要生成付款账单，请让管理员添加销售网点',
    STATUS: {
      WAITING: '待处理',
      PAID: '已支付',
      EXPIRED: '已过期',
      CANCELLED_BY_SENDER: '已撤销',
      REJECTED_BY_PAYER: '已拒绝',
    },
    RULES: {
      MAX_SUM: '付款金额不能超过{sum} 索姆。',
    },
    OUTGOING_STATUS: {
      ALL: '全部',
      ISSUED: '已开具',
      PAID: '已支付',

      PARTIALLY_PAID: '部分支付',
      REJECTED: '已拒绝',
      CANCELLED: '已取消',
      EXPIRED: '已过期',
      DRAFT: '草稿',
      TITLE: '付款账单',
      LEGAL_ENTITY: '给法人',
      BUYER_NAME: '购买方名称',
      COMMENT: '账单备注',
    },
    INCOMING_STATUS: {
      ALL: '全部',
      ISSUED: '已开具',
      PAID: '已支付',

      PARTIALLY_PAID: '部分支付',
      REJECTED: '已拒绝',
      CANCELLED: '已取消',
      EXPIRED: '已过期',
      TITLE: '付款账单',
      LEGAL_ENTITY: '给法人',
      SELLER_NAME: '卖方名称',
      COMMENT: '账单备注',
    },
    OUTGOING_FILTER: {
      BUYER_NAME: '购买方名称',
      SORT_AMOUNT: '金额',
      SORT_AMOUNT_ASC: '升序',
      SORT_AMOUNT_DESC: '降序',
    },
    INCOMING_FILTER: {
      SELLER_NAME: '卖方名称',
      SORT_AMOUNT: '金额',
      SORT_AMOUNT_ASC: '升序',
      SORT_AMOUNT_DESC: '降序',
    },
    DETAILS: {
      PURPOSE: '用途/备注',
      OPEN: '打开账单',
      INVOICE_NUMBER: '账单编号',
      EXPIRES_AT: '账单有效期',
      CREATED_BY: '创建人',
      INVOICE_TYPE: '付款方类型',
      INVOICE_TYPE_INTERNAL: '行内',
      INVOICE_TYPE_EXTERNAL: '跨行',
      BUYER_TITLE: '交易方',
      BUYER_LABEL: '税号/名称',
      PRODUCTS: '商品/服务',
    },
  },
  USER_APPROVE: {
    APPROVE_ACCOUNT: '请前往银行网点验证账户 打开所有可能性',
    APPROVE_ACCOUNT_SHORT: '验证账户',
    APPROVE_ACCOUNT_FOR_OPERATIONS: '请前往银行网点验证账户，以获取全部操作权限',
    ACCOUNT_NOT_APPROVE: '账户未验证',
    CREDIT: {
      TITLE: '贷款与分期支付',
      DESCRIPTION: '开通贷款及分期产品',
    },
    TRANSFER: {
      TITLE: '跨行转账',
      DESCRIPTION: '向合作伙伴转账，无限额',
    },
    LIMITS: {
      TITLE: '更高额度',
      DESCRIPTION: '进行大额交易，金额无限制',
    },
    LIMIT_TRANSFER: {
      TITLE: '* 行内转账限额：',
      ONE_OPERATION: '• 单笔交易 — 最高 200,000 索姆',
      MONTH_OPERATION: '• 月度总额 — 最高 400,000 索姆',
    },
  },
  BANK_OFFICES: {
    TITLE: '分行地图',
    SEARCH_PLACEHOLDER: '输入分行地址',
    EMPTY: '未找到分行',
  },
  REQUISITES: {
    TITLE: '详细信息',
    COMPANY_NAME: '公司名称',
    LEGAL_ADDRESS: '法定地址',
    INTERMEDIARY_BANK: '中间行',
    CORRESPONDENT_ACCOUNT: '代理行账户',
    IBAN: 'IBAN',
    IKK: 'IКК',
    BIN: '银行代码',
    SWIFT: 'SWIFT',
    INN: '纳税人识别码',
    STIN: '客户编号',
    TIN: 'TIN',
    CNAPS: '银行 CNAPS 代码',
    ACCOUNT_NO: '账号',
    LOCAL_BIC: '本地银行标识码',
    SWIFT_BIC: '银行国际 SWIFT/BIC 代码',
    ROUTING_NUMBER: 'Routing number (ABA)',
    KBE: '哈萨克斯坦付款专用预算单位代码',
    INFO: '附加信息',
    BENEFICIARY_BANK: '收款行',
    PURPOSE: '付款用途（限140个字符）',
    PDF: '导出为 PDF',
    COPY: '复制账户信息',
    INFO_ACCOUNT: '账户信息',
    HISTORY: '记录',
  },
};
